import { AnalyticsService } from './analytics.service';
import * as $ from 'jquery';
var Month;
(function (Month) {
    Month[Month["JANUARY"] = 0] = "JANUARY";
    Month[Month["FEBRUARY"] = 1] = "FEBRUARY";
    Month[Month["MARCH"] = 2] = "MARCH";
    Month[Month["APRIL"] = 3] = "APRIL";
    Month[Month["MAY"] = 4] = "MAY";
    Month[Month["JUNE"] = 5] = "JUNE";
    Month[Month["JULY"] = 6] = "JULY";
    Month[Month["AUGUST"] = 7] = "AUGUST";
    Month[Month["SEPTEMBER"] = 8] = "SEPTEMBER";
    Month[Month["OCTOBER"] = 9] = "OCTOBER";
    Month[Month["NOVEMBER"] = 10] = "NOVEMBER";
    Month[Month["DECEMBER"] = 11] = "DECEMBER";
})(Month || (Month = {}));
var AmortisationItem = /** @class */ (function () {
    function AmortisationItem() {
        this.payment = 0.0;
        this.extraPayment = 0.0;
        this.missedPaymentAndRevolves = 0.0;
        this.monthlyServiceFee = 0.0;
        this.insuranceCost = 0.0;
        this.interest = 0.0;
        this.balance = 0.0;
        this.interestRate = 0.0;
    }
    return AmortisationItem;
}());
var WpbbsaCalculatorService = /** @class */ (function () {
    function WpbbsaCalculatorService() {
        this.analyticsService = new AnalyticsService();
    }
    WpbbsaCalculatorService.getInstance = function () {
        if (!WpbbsaCalculatorService.instance) {
            WpbbsaCalculatorService.instance = new WpbbsaCalculatorService();
        }
        return WpbbsaCalculatorService.instance;
    };
    // DETECT CALCULATOR
    WpbbsaCalculatorService.prototype.detect = function (form) {
        switch (form.id) {
            case 'wpbbsa-calculator-personal-loans_loan-calculator':
                this.doPL1(form);
                break;
            case 'wpbbsa-calculator-vaf':
                this.doVAF1(form);
                break;
            case 'calculator-vaf_how_much_can_i_afford':
                this.doVAF2(form);
                break;
            case 'calculator-vaf_finance_calculator':
                this.doVAF3(form);
                break;
            case 'wpbbsa-calculator-personal-loans_student-loan-calculator':
                this.doSL1(form);
                break;
            default:
                break;
        }
    };
    WpbbsaCalculatorService.prototype.initializeWpbbsaCalculator = function (form) {
        var _iniCalc = null;
        switch (form.id) {
            case 'wpbbsa-calculator-personal-loans_amortisation-calculator':
                _iniCalc = this.initializeWpbbsaAmortisationCalculator(form);
                break;
            default:
                break;
        }
        return _iniCalc;
    };
    WpbbsaCalculatorService.prototype.initializeWpbbsaAmortisationCalculator = function (calcForm) {
        var newAmortisationCalculator = new WpbbsaCalculatorPersonalloansAmortisation();
        newAmortisationCalculator.calculatorForm = calcForm;
        newAmortisationCalculator.calculatorMain = calcForm.closest('.component.wpbbsa-calculators-v2');
        newAmortisationCalculator.calculatorItemElement = calcForm.closest('.wpbbsa-calculator-item-v2');
        newAmortisationCalculator.calculatorInfo = newAmortisationCalculator.calculatorItemElement.querySelector('.wpbbsa-calculator-item-v2__box--gradient-blue');
        newAmortisationCalculator.inputs = Array.from(calcForm.querySelectorAll("input, select"));
        newAmortisationCalculator.calculatorSubmit = newAmortisationCalculator.calculatorForm.querySelector(".js-wpbbsa-calculators-v2-plua-calculate");
        newAmortisationCalculator.calculatorReset = newAmortisationCalculator.calculatorForm.querySelector(".js-wpbbsa-calculators-v2-plua-reset");
        newAmortisationCalculator.sliders = Array.from(newAmortisationCalculator.calculatorForm.querySelectorAll('.wpbbsa-calculator-form-v2__input--range'));
        newAmortisationCalculator.loanTypeSelect = newAmortisationCalculator.calculatorForm.querySelector("select[name='loan-type']");
        newAmortisationCalculator.loanType = "TERM LOAN";
        newAmortisationCalculator.dataHtmlCollection = Array.from(newAmortisationCalculator.calculatorItemElement.getElementsByClassName("form__group wpbbsa-calculator-form-v2__group"));
        newAmortisationCalculator.dataHtmlCollection.forEach(function (item, index) {
            if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-first") != -1) {
                var itemParent = item.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                itemParent.classList.remove("wpbbsa-calculators-v2__hidden");
                // item.classList.remove("hidden");
            }
            if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-second") != -1) {
                var itemParent = item.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                itemParent.classList.add("wpbbsa-calculators-v2__hidden");
                // item.classList.add("hidden");
            }
        });
        newAmortisationCalculator.numberOfAdditionalPayments = 0;
        newAmortisationCalculator.numberOfMissedPayments = 0;
        newAmortisationCalculator.numberOfRevolves = 0;
        newAmortisationCalculator.loanTypeFormTitle = newAmortisationCalculator.calculatorForm.querySelector("label[for='loan-amount']");
        newAmortisationCalculator.loanTypeTitle = newAmortisationCalculator.calculatorItemElement.querySelector(".js-wpbbsa-calculator-loan-amount--title-info-left");
        newAmortisationCalculator.loanTypeFormStartDateTitle = newAmortisationCalculator.calculatorForm.querySelector("label[for='date-of-loan']");
        newAmortisationCalculator.loanTypeStartDateTitle = newAmortisationCalculator.calculatorItemElement.querySelector(".js-wpbbsa-calculator-date-of-loan--title-info-left");
        newAmortisationCalculator.madeAdditionalPayments = newAmortisationCalculator.calculatorForm.querySelector("input[name='made-additional-payments']");
        newAmortisationCalculator.additionalPaymentItems = newAmortisationCalculator.calculatorForm.querySelector("div[name='additional-payment-items']");
        newAmortisationCalculator.addRemoveAdditionalPayments = newAmortisationCalculator.calculatorForm.querySelector(".add-remove-additional-payments");
        newAmortisationCalculator.addAdditionalPaymentDiv = newAmortisationCalculator.calculatorForm.querySelector(".add-additional-payment");
        newAmortisationCalculator.addAdditionalPaymentBtn = newAmortisationCalculator.calculatorForm.querySelector("button[name=add-additional-payment-btn]");
        newAmortisationCalculator.removeAdditionalPaymentDiv = newAmortisationCalculator.calculatorForm.querySelector(".remove-additional-payment");
        newAmortisationCalculator.removeAdditionalPaymentBtn = newAmortisationCalculator.calculatorForm.querySelector("button[name='remove-additional-payment-btn']");
        newAmortisationCalculator.haveMissedPayments = newAmortisationCalculator.calculatorForm.querySelector("input[name='missed-payments']");
        newAmortisationCalculator.missedPaymentItems = newAmortisationCalculator.calculatorForm.querySelector("div[name='missed-payment-items']");
        newAmortisationCalculator.addRemoveMissedPayments = newAmortisationCalculator.calculatorForm.querySelector(".add-remove-missed-payments");
        newAmortisationCalculator.addMissedPaymentDiv = newAmortisationCalculator.calculatorForm.querySelector(".add-missed-payment");
        newAmortisationCalculator.addMissedPaymentBtn = newAmortisationCalculator.calculatorForm.querySelector("button[name='add-missed-payment-btn']");
        newAmortisationCalculator.removeMissedPaymentDiv = newAmortisationCalculator.calculatorForm.querySelector(".remove-missed-payment");
        newAmortisationCalculator.removeMissedPaymentBtn = newAmortisationCalculator.calculatorForm.querySelector("button[name='remove-missed-payment-btn']");
        newAmortisationCalculator.revolved = newAmortisationCalculator.calculatorForm.querySelector("input[name='revolved']");
        newAmortisationCalculator.revolvedItems = newAmortisationCalculator.calculatorForm.querySelector("div[name='revolved-items']");
        // newAmortisationCalculator.revolvedEmptySpaceDiv = newAmortisationCalculator.calculatorForm.querySelector(
        // 	"div.revolved-empty-space__group-parent-div"
        // );
        newAmortisationCalculator.addRemoveRevolves = newAmortisationCalculator.calculatorForm.querySelector(".add-remove-revolves");
        newAmortisationCalculator.addRevolvedDiv =
            newAmortisationCalculator.calculatorForm.querySelector(".add-revolved");
        newAmortisationCalculator.addRevolvedBtn = newAmortisationCalculator.calculatorForm.querySelector("button[name='add-revolved-btn']");
        newAmortisationCalculator.removeRevolvedDiv =
            newAmortisationCalculator.calculatorForm.querySelector(".remove-revolved");
        newAmortisationCalculator.removeRevolvedBtn = newAmortisationCalculator.calculatorForm.querySelector("button[name='remove-revolved-btn']");
        newAmortisationCalculator.amortisationTableLabel = newAmortisationCalculator.calculatorMain.querySelector("#form-container-amortisation-table label[name='amortisation-table']");
        newAmortisationCalculator.analyticsService = new AnalyticsService();
        newAmortisationCalculator.wpbbsaCalculatorService = new WpbbsaCalculatorService();
        if (newAmortisationCalculator.loanTypeSelect) {
            newAmortisationCalculator.updateFormLoanType(newAmortisationCalculator.loanType);
        }
        // Check if mobile view
        newAmortisationCalculator.checkIfMobile();
        // Initialise sliders
        newAmortisationCalculator.initialiseSliders();
        return newAmortisationCalculator;
    };
    WpbbsaCalculatorService.prototype.initializeDatePickers = function () {
        $(document).ready(function () {
            if ($('input.js-date-picker')) {
                var datePickerConfig = {
                    todayHighlight: true,
                    format: 'yyyy/mm/dd',
                    daysOfWeekDisabled: [0, 6],
                    enableOnReadonly: true,
                    autoclose: true,
                    endDate: new Date()
                };
                instantiateDate('.js-date-picker', datePickerConfig);
            }
            if ($('input.js-date-picker-full')) {
                var datePickerConfig = {
                    todayHighlight: true,
                    format: 'yyyy/mm/dd',
                    enableOnReadonly: true,
                    autoclose: true,
                    endDate: new Date()
                };
                instantiateDate('.js-date-picker-full', datePickerConfig);
            }
            function instantiateDate(pSelector, pConfig) {
                $('input' + pSelector).datepicker(pConfig).on('changeDate', function (event) {
                    var _event;
                    if (typeof window.event === 'function') {
                        _event = new Event('change');
                        this.dispatchEvent(_event);
                    }
                    else {
                        _event = document.createEvent('HTMLEvents');
                        _event.initEvent('change', false, false);
                        this.dispatchEvent(_event);
                    }
                });
            }
        });
    };
    // -- PERSONAL LOANS CALCULATORS -- //
    // PERSONAL LOANS MONTHLY REPAYMENTS
    WpbbsaCalculatorService.prototype.doPL1 = function (form) {
        var total = 0;
        var loanamount = form.querySelector('input[name=initial_value]');
        total = parseFloat(loanamount.value);
        var interest = form.querySelector('input[name=variable_interest_rate]');
        var term = form.querySelector('input[name=term]');
        var output_borrow = document.querySelectorAll('span.js-wpbbsa-calculator-estimated-repayment-pl1');
        var output_months = document.querySelectorAll('span.js-wpbbsa-calculator-loan-period-pl1');
        var output_date = document.querySelectorAll('span.js-wpbbsa-calculator-first-repayment-date-pl1');
        var output_fees = document.querySelectorAll('span.js-wpbbsa-calculator-total-interest-pl1');
        if (loanamount && loanamount.value !== '0' && loanamount.value !== '') {
            var answer_1 = this.PLMonthlyRepayments(total, interest.value, term.value);
            [].slice.call(output_borrow).forEach(function (div) {
                div.innerHTML = answer_1.estimatedMonthlyRepayment;
            });
            [].slice.call(output_date).forEach(function (div) {
                div.innerHTML = answer_1.date;
            });
            [].slice.call(output_fees).forEach(function (div) {
                div.innerHTML = answer_1.totalInterest;
            });
            // Analytics - Trigger form Complete when the user calculates the results
            this.analyticsService.dtmFormComplete("complete", "");
        }
    };
    // PERSONAL LOANS MONTHLY REPAYMENTS
    WpbbsaCalculatorService.prototype.PLMonthlyRepayments = function (loanamount, loaninterest, loanterm) {
        if (loanamount === void 0) { loanamount = 0; }
        if (loaninterest === void 0) { loaninterest = 0; }
        if (loanterm === void 0) { loanterm = 10.25; }
        var initiationFee = Math.min(1050, 165 + 0.1 * (loanamount - 1000)) * 1.15;
        var serviceFee = 60 * 1.15;
        var normalValue = loanamount / loanterm;
        normalValue = this.round(normalValue, 2);
        var final = -this.pmt_vaf(loaninterest / 1200, loanterm, (loanamount + initiationFee), 0, 0) + serviceFee;
        final = this.round(final, 2);
        var monthlyInterestAndFees = this.round((final / loanterm), 2);
        var interestTotal = this.round((final - normalValue), 2);
        var todaysDate = new Date();
        var getMonth = todaysDate.getMonth();
        todaysDate.setMonth(getMonth + 1, 1);
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return {
            date: "1 " + monthNames[todaysDate.getMonth()] + " " + todaysDate.getFullYear(),
            iFee: initiationFee,
            sFee: serviceFee,
            totalMonthlyInterestAndFees: monthlyInterestAndFees,
            totalInterest: this.formatter(interestTotal),
            estimatedMonthlyRepayment: this.formatter(final)
        };
    };
    // -- VAF CALCULATORS -- //
    // VAF CALCULATOR MONTHLY REPAYMENTS
    WpbbsaCalculatorService.prototype.doVAF1 = function (form) {
        var purchaseprice = form.querySelector('input[name=purchase_price]');
        var deposit = form.querySelector('input[name=deposit]');
        var term = form.querySelector('input[name=term]');
        var balloon = form.querySelector('input[name=balloon]');
        var interest = form.querySelector('input[name=variable_interest_rate]');
        var output_estimate = document.querySelectorAll('span.js-wpbbsa-calculator-estimated-repayment-vaf1');
        var output_total_paid = document.querySelectorAll('span.js-wpbbsa-calculator-total-paid-vaf1');
        var answer = this.VAFMonthlyRepayments(purchaseprice.value, deposit.value, balloon.value, 0, term.value, interest.value);
        [].slice.call(output_estimate).forEach(function (div) {
            div.innerHTML = answer.monthlyRepayment;
        });
        [].slice.call(output_total_paid).forEach(function (div) {
            div.innerHTML = answer.totalPaid;
        });
        if (answer.monthlyRepayment !== '0') {
            // Analytics - Trigger form Complete when the user calculates the results
            this.analyticsService.dtmFormComplete("complete", "");
        }
    };
    WpbbsaCalculatorService.prototype.doVAF2 = function (form) {
        var total = 0;
        var gross = form.querySelectorAll('input[name=gross_monthly_income]');
        var expenses = form.querySelector('input[name=monthly_expenses]');
        var output_available = document.querySelectorAll('span.js-wpbbsa-calculator-available');
        [].slice.call(gross).forEach(function (input) {
            if (input.value) {
                total += parseFloat(input.value);
            }
        });
        var answer = this.VAFHowMuchCanIAfford(total, expenses.value);
        [].slice.call(output_available).forEach(function (div) {
            div.innerHTML = answer.availablePerMonth;
        });
        // Analytics - Trigger form Complete when the user calculates the results
        this.analyticsService.dtmFormComplete("complete", "");
    };
    WpbbsaCalculatorService.prototype.doVAF3 = function (form) {
        var preferredrepayment = form.querySelector('input[name=preferred_monthly_repayment]');
        var deposit = form.querySelector('input[name=deposit_2]');
        var term = form.querySelector('input[name=term_2]');
        var interest = form.querySelector('input[name=variable_interest_rate_2]');
        var output_amount = document.querySelectorAll('span.js-wpbbsa-calculator-amount-i-can-spend-vaf3');
        if (deposit.value == null || deposit.value === '') {
            deposit.value = 0;
        }
        var answer = this.VAFVehiclePurchasePrice(preferredrepayment.value, deposit.value, term.value, interest.value);
        [].slice.call(output_amount).forEach(function (div) {
            div.innerHTML = answer.amount;
        });
        // Analytics - Trigger form Complete when the user calculates the results
        this.analyticsService.dtmFormComplete("complete", "");
    };
    // VAF CALCULATOR MONTHLY REPAYMENTS
    WpbbsaCalculatorService.prototype.VAFMonthlyRepayments = function (purchaseprice, deposit, baloonpercentage, baloonamount, loanterm, interest) {
        if (purchaseprice === void 0) { purchaseprice = 0; }
        if (deposit === void 0) { deposit = 0; }
        if (baloonpercentage === void 0) { baloonpercentage = 0; }
        if (baloonamount === void 0) { baloonamount = 0; }
        if (loanterm === void 0) { loanterm = 0; }
        if (interest === void 0) { interest = 10.25; }
        if (purchaseprice == 0) {
            return {
                monthlyRepayment: this.formatter(0),
                totalPaid: this.formatter(0)
            };
        }
        var monthlyRepayment = 0;
        var totalPaid = 0;
        var getLoan = 0;
        var getFinalLoan = 0;
        var getPayments = 0;
        var getDeposit = deposit;
        var getBalloonAmt = baloonamount;
        var getAmtAdminFee = 69.30;
        var i = interest;
        i = i / 100.0;
        i /= 12;
        var pow = 1;
        var j = 0;
        while (j < loanterm) {
            pow = pow * (1 + i);
            j++;
        }
        getLoan = purchaseprice - deposit;
        getBalloonAmt = baloonpercentage * purchaseprice / 100;
        getFinalLoan = (getLoan - getBalloonAmt / pow);
        getPayments = (getFinalLoan * pow * i) / (pow - 1);
        // monthlyRepayment = getPayments + getAmtAdminFee;
        monthlyRepayment = getPayments;
        totalPaid = (getPayments + getAmtAdminFee) * loanterm;
        if (baloonpercentage > 0) {
            totalPaid = getBalloonAmt + totalPaid;
        }
        return {
            monthlyRepayment: this.formatter(monthlyRepayment),
            totalPaid: this.formatter(totalPaid)
        };
    };
    // VEHICLE AND ASSET FINANCE
    WpbbsaCalculatorService.prototype.VAFHowMuchCanIAfford = function (gross, expenses) {
        if (gross === void 0) { gross = 0; }
        if (expenses === void 0) { expenses = 0; }
        var amount = gross - expenses;
        return {
            availablePerMonth: this.formatter(amount)
        };
    };
    // VEHICLE AND ASSET FINANCE
    WpbbsaCalculatorService.prototype.VAFVehiclePurchasePrice = function (preferredpayment, deposit, loanterm, interest) {
        if (preferredpayment === void 0) { preferredpayment = 0; }
        if (deposit === void 0) { deposit = 0; }
        if (loanterm === void 0) { loanterm = 0; }
        if (interest === void 0) { interest = 10.25; }
        var amount = 0;
        var depositString = deposit;
        var i = interest;
        i = i / 100.0;
        i /= 12;
        var j = 0;
        var pow = 1;
        while (j < loanterm) {
            pow = pow * (1 + i);
            j++;
        }
        amount = (preferredpayment * (1 - Math.pow(1 + i, -loanterm)) / i) + deposit;
        var amountFinal = parseFloat(amount) + parseFloat(depositString);
        return {
            amount: this.formatter(amountFinal)
        };
    };
    WpbbsaCalculatorService.prototype.doSL1 = function (form) {
        var MONTHLY_PAYMENT_1_STUDENT_NOONE_TEXT = 'Your estimated monthly repayment';
        var MONTHLY_PAYMENT_1_SURETY_TEXT = 'Estimated monthly interest and fees repayment';
        var MONTHLY_PAYMENT_1_SURETY_SUBTEXT = '*To be paid while studying';
        var MONTHLY_PAYMENT_1_NOONE_SUBTEXT = '*To be paid upon completion of studies';
        var MONTHLY_PAYMENT_2_STUDENT_NOONE_TEXT = 'Monthly interest and fees';
        var MONTHLY_PAYMENT_2_SURETY_TEXT = 'Estimated monthly repayments';
        var MONTHLY_PAYMENT_2_SURETY_SUBTEXT = '*To be paid upon completion of studies calculated over a 60 month term';
        var calculatedInfo = form.closest('.wpbbsa-calculator-item-v2');
        var loanamount = form.querySelector('input[name=sl_loan_amount]');
        var interest = form.querySelector('input[name=loan_interest_rate]');
        var term = form.querySelector('input[name=sl_loan_term]');
        var loanterm = form.querySelector('input[name=sl_loan_term]');
        var monthlyPaymentFees1Div = calculatedInfo.querySelectorAll('div.js-wpbbsa-calculator-sl-monthly-payment-1--title-data-content');
        var monthlyPaymentFees1 = calculatedInfo.querySelectorAll('span.js-wpbbsa-calculator-sl-monthly-payment-1');
        var monthlyPaymentFees1SubtitleDiv = calculatedInfo.querySelectorAll('span.wpbbsa-calculator-item-v2__subtitle');
        var monthlyPaymentFees2InfoLeft = calculatedInfo.querySelectorAll('div.js-wpbbsa-calculator-sl-monthly-payment-2--title-info-left');
        var monthlyPaymentFees2InfoRight = calculatedInfo.querySelectorAll('span.js-wpbbsa-calculator-sl-monthly-payment-2--value');
        var monthlyPaymentFees2Subinfo = calculatedInfo.querySelectorAll('div.js-wpbbsa-calculator-sl-monthly-payment-2--subinfo');
        var answer = {};
        var _personToPayLoan = form.querySelector("select[name=\"person-to-pay-loan\"]");
        if (loanamount.value !== '' && loanamount.value !== '0'
            && interest.value !== '' && interest.value !== '0'
            && term.value !== '' && term.value !== '0') {
            if (_personToPayLoan.value === "STUDENT" || _personToPayLoan.value === "NOONE") {
                answer = this.doStudentCalc(loanamount.value, interest.value, term.value);
            }
            else if (_personToPayLoan.value === "SURETY") {
                answer = this.doSuretyCalc(loanamount.value, interest.value);
            }
            else {
                answer = { monthlyPaymentFees1: '0', monthlyPaymentFees2: '0' };
            }
            if (_personToPayLoan.value === 'STUDENT' || _personToPayLoan.value === "NOONE") {
                // -- ** STUDENT AND NOONE DISPLAY TEXT ** -- //
                [].slice.call(monthlyPaymentFees1Div).forEach(function (div) {
                    div.innerHTML = MONTHLY_PAYMENT_1_STUDENT_NOONE_TEXT;
                });
                if (_personToPayLoan.value === "NOONE") {
                    [].slice.call(monthlyPaymentFees1SubtitleDiv).forEach(function (div) {
                        div.classList.remove('wpbbsa-calculators-v2__hidden');
                    });
                    [].slice.call(monthlyPaymentFees1SubtitleDiv).forEach(function (div) {
                        div.innerHTML = MONTHLY_PAYMENT_1_NOONE_SUBTEXT;
                    });
                }
                else {
                    [].slice.call(monthlyPaymentFees1SubtitleDiv).forEach(function (div) {
                        div.classList.add('wpbbsa-calculators-v2__hidden');
                    });
                    [].slice.call(monthlyPaymentFees1SubtitleDiv).forEach(function (div) {
                        div.innerHTML = '';
                    });
                }
                [].slice.call(monthlyPaymentFees2InfoLeft).forEach(function (div) {
                    div.innerHTML = MONTHLY_PAYMENT_2_STUDENT_NOONE_TEXT;
                });
                [].slice.call(monthlyPaymentFees2Subinfo).forEach(function (div) {
                    div.classList.add('wpbbsa-calculators-v2__hidden');
                });
                [].slice.call(monthlyPaymentFees2Subinfo).forEach(function (div) {
                    div.innerHTML = '';
                });
                // -- ** STUDENT AND NOONE DISPLAY TEXT END ** -- //
                // -- ** STUDENT AND NOONE CALCULATIONS ** -- //
                [].slice.call(monthlyPaymentFees1).forEach(function (div) {
                    div.innerHTML = (answer.monthlyPaymentFees1 !== '0') ? Number(answer.monthlyPaymentFees1).toFixed(2) : '0';
                });
                [].slice.call(monthlyPaymentFees2InfoRight).forEach(function (div) {
                    div.innerHTML = (answer.monthlyPaymentFees2 !== '0') ? Number(answer.monthlyPaymentFees2).toFixed(2) : '0';
                });
                // -- ** STUDENT AND NOONE CALCULATIONS ** END -- //
                // Analytics - Trigger form Complete when the user calculates the results
                this.analyticsService.dtmFormComplete('complete', '');
            }
            else if (_personToPayLoan.value === "SURETY") {
                // -- ** SURETY DISPLAY TEXT ** -- //
                [].slice.call(monthlyPaymentFees1Div).forEach(function (div) {
                    div.innerHTML = MONTHLY_PAYMENT_1_SURETY_TEXT;
                });
                [].slice.call(monthlyPaymentFees1SubtitleDiv).forEach(function (div) {
                    div.classList.remove('wpbbsa-calculators-v2__hidden');
                });
                [].slice.call(monthlyPaymentFees1SubtitleDiv).forEach(function (div) {
                    div.innerHTML = MONTHLY_PAYMENT_1_SURETY_SUBTEXT;
                });
                [].slice.call(monthlyPaymentFees2InfoLeft).forEach(function (div) {
                    div.innerHTML = MONTHLY_PAYMENT_2_SURETY_TEXT;
                });
                [].slice.call(monthlyPaymentFees2Subinfo).forEach(function (div) {
                    div.classList.remove('wpbbsa-calculators-v2__hidden');
                });
                [].slice.call(monthlyPaymentFees2Subinfo).forEach(function (div) {
                    div.innerHTML = MONTHLY_PAYMENT_2_SURETY_SUBTEXT;
                });
                // -- ** SURETY DISPLAY TEXT END ** -- //
                // -- ** SURETY CALCULATIONS ** -- //
                [].slice.call(monthlyPaymentFees1).forEach(function (div) {
                    div.innerHTML = (answer.monthlyPaymentFees1 !== '0') ? Number(answer.monthlyPaymentFees1).toFixed(2) : '0';
                });
                [].slice.call(monthlyPaymentFees2InfoRight).forEach(function (div) {
                    div.innerHTML = (answer.monthlyPaymentFees2 !== '0') ? Number(answer.monthlyPaymentFees2).toFixed(2) : '0';
                });
                // -- ** SURETY CALCULATIONS END ** -- //
                // Analytics - Trigger form Complete when the user calculates the results
                this.analyticsService.dtmFormComplete('complete', '');
            }
            else {
                // -- ** DISPLAY TEXT ** -- //
                [].slice.call(monthlyPaymentFees1Div).forEach(function (div) {
                    div.innerHTML = MONTHLY_PAYMENT_1_STUDENT_NOONE_TEXT;
                });
                [].slice.call(monthlyPaymentFees1SubtitleDiv).forEach(function (div) {
                    div.classList.add('wpbbsa-calculators-v2__hidden');
                });
                [].slice.call(monthlyPaymentFees1SubtitleDiv).forEach(function (div) {
                    div.innerHTML = '';
                });
                [].slice.call(monthlyPaymentFees2InfoLeft).forEach(function (div) {
                    div.innerHTML = MONTHLY_PAYMENT_2_STUDENT_NOONE_TEXT;
                });
                [].slice.call(monthlyPaymentFees2Subinfo).forEach(function (div) {
                    div.classList.add('wpbbsa-calculators-v2__hidden');
                });
                [].slice.call(monthlyPaymentFees2Subinfo).forEach(function (div) {
                    div.innerHTML = '';
                });
                // -- ** DISPLAY TEXT END ** -- //
                // -- ** CALCULATIONS ** -- //
                [].slice.call(monthlyPaymentFees1).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(monthlyPaymentFees2InfoRight).forEach(function (div) {
                    div.innerHTML = '0';
                });
                // -- ** CALCULATIONS END ** -- //
            }
        }
        // Analytics - Trigger form Complete when the user calculates the results
        this.analyticsService.dtmFormComplete("complete", "");
    };
    WpbbsaCalculatorService.prototype.doStudentCalc = function (loanAmount, totIntRateCharged, loanTerm) {
        var monthlyServiceFee = 69; // Constant
        var totIntRateChargedPercntg = Number(totIntRateCharged) / 100;
        var paymentsPerYear = 12; // Constant
        var initiationFee = 74.75 + (0.115 * Number(loanAmount));
        if (initiationFee > 1207.5) {
            initiationFee = 1207.5;
        }
        var principleDebt = initiationFee + Number(loanAmount);
        var pmt = principleDebt * ((totIntRateChargedPercntg / paymentsPerYear) / (1 - (Math.pow(1 + (totIntRateChargedPercntg / paymentsPerYear), ((-1) * Number(loanTerm))))));
        var totalRepayment = (pmt * Number(loanTerm)) + (monthlyServiceFee * Number(loanTerm));
        var monthlyPaymentFees1 = totalRepayment / Number(loanTerm);
        var monthlyPaymentFees2 = (totalRepayment - Number(loanAmount)) / Number(loanTerm);
        return { monthlyPaymentFees1: monthlyPaymentFees1, monthlyPaymentFees2: monthlyPaymentFees2 };
    };
    WpbbsaCalculatorService.prototype.doSuretyCalc = function (loanAmount, totIntRateCharged) {
        var monthlyServiceFee = 69; // Constant
        var loanTermFTWS = 12; // Constant
        var loanTermFTAS = 60; // Constant
        var totIntRateChargedPercntg = Number(totIntRateCharged) / 100;
        var paymentsPerYear = 12; // Constant
        var initiationFee = 74.75 + (0.115 * Number(loanAmount));
        if (initiationFee > 1207.5) {
            initiationFee = 1207.5;
        }
        // Full Time While Studying
        var principleDebtFTWS = initiationFee + Number(loanAmount);
        var monthlyPaymentFees1WS = ((principleDebtFTWS * totIntRateChargedPercntg) / loanTermFTWS) + monthlyServiceFee + 50;
        var totalFeesWS = monthlyPaymentFees1WS * loanTermFTWS;
        // Full Time After Studying
        var pmt = principleDebtFTWS * ((totIntRateChargedPercntg / paymentsPerYear) / (1 - (Math.pow(1 + (totIntRateChargedPercntg / paymentsPerYear), ((-1) * loanTermFTAS)))));
        var totalFeesAS = (pmt * loanTermFTAS) + (monthlyServiceFee * loanTermFTAS);
        var monthlyPaymentFees1AS = totalFeesAS / loanTermFTAS;
        var monthlyPaymentFees1 = 0;
        var monthlyPaymentFees2 = 0;
        return { monthlyPaymentFees1: monthlyPaymentFees1WS, monthlyPaymentFees2: monthlyPaymentFees1AS };
    };
    //
    //
    // CUSTOM CALCULATOR VALIDATIONS
    //
    //
    WpbbsaCalculatorService.prototype.validateWpbbsaCalculator = function (event, form) {
        // varaibles
        event.preventDefault();
        var field = event.target;
        var formValid = true;
        var fieldName = field.name;
        var fieldValue = field.value;
        var fieldAddon = field;
        var required = field.getAttribute('data-validation-required');
        var title = field.getAttribute('data-validation-title');
        var minimum = parseFloat(field.getAttribute('min'));
        var maximum = parseFloat(field.getAttribute('max'));
        var greaterThan = field.getAttribute('data-validation-greater-than');
        var lessThan = field.getAttribute('data-validation-less-than');
        // removeErrors
        $(field).closest('.wpbbsa-calculator-form-v2__group').removeClass('wpbbsa-calculator-form-v2__error');
        $(field).closest('.wpbbsa-calculator-form-v2__group').find('div.wpbbsa-calculator-form-v2__error-label').remove();
        // required
        if (required == "true") {
            if (field.type == "text" || field.type == "number" || field.type == "select" || field.type == "select-one") {
                if (fieldValue.length == 0 || fieldValue == "" || fieldValue == null) {
                    formValid = false;
                    this.validateCalculatorError(event, 'This field is required');
                }
            }
            else if (fieldValue.length == 0) {
                formValid = false;
                if (minimum) {
                    if (maximum) {
                        if (title) {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                        }
                        else {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                        }
                    }
                    else {
                        this.validateCalculatorError(event, 'Enter an amount');
                    }
                }
                else {
                    this.validateCalculatorError(event, 'Enter an amount');
                }
            }
        }
        //check date
        if (field.type == "text" && field.classList.contains('form__datepicker')) {
            if (fieldValue != "" && fieldValue != null) {
                var date = new Date(fieldValue);
                if (date.toString().toUpperCase() == "INVALID DATE" || isNaN(Date.parse(fieldValue))) {
                    this.validateCalculatorError(field, 'Invalid date');
                }
                else if (date > new Date()) {
                    this.validateCalculatorError(field, 'Cannot use selected date');
                }
            }
        }
        // check text field
        if ((field.type == "text" || field.type == "number") && !field.classList.contains('form__datepicker')) {
            if (fieldValue != "" && fieldValue != null) {
                var floatCheck = /^[0-9]*\.?[0-9]+$/;
                if (!floatCheck.test(fieldValue)) {
                    formValid = false;
                    this.validateCalculatorError(event, 'Please enter only numbers');
                }
                else {
                    // min
                    if (minimum > parseFloat(fieldValue)) {
                        formValid = false;
                        if (title && maximum) {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                        }
                        else if (!title && maximum) {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                        }
                        else if (!title && !maximum) {
                            this.validateCalculatorError(event, 'Enter an amount');
                        }
                    }
                    // max
                    if (maximum > 0) {
                        if (maximum < parseFloat(fieldValue)) {
                            formValid = false;
                            if (title) {
                                this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                            }
                            else {
                                this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                            }
                        }
                    }
                    else {
                        if (maximum < parseFloat(fieldValue)) {
                            formValid = false;
                            if (title) {
                                this.validateCalculatorError(event, 'The maximum you can insert is 0 ' + title);
                            }
                            else {
                                this.validateCalculatorError(event, 'The maximum you can insert is 0');
                            }
                        }
                    }
                    // greater than
                    if (greaterThan) {
                        var fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
                        if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
                            formValid = false;
                            this.validateCalculatorError(event, 'Enter an amount greater than the expenses field');
                        }
                    }
                    // less than
                    if (lessThan) {
                        var fieldsLessThan = $(field).closest('form').find('input[name=' + lessThan + ']');
                        if (fieldsLessThan.length > 1) {
                            var amount_1 = 0;
                            $(fieldsLessThan).each(function (index) {
                                var valueElement = $(this).val();
                                if (!valueElement) {
                                    amount_1 = amount_1 + 0;
                                }
                                else {
                                    amount_1 = amount_1 + parseFloat(valueElement);
                                }
                            });
                            if (parseFloat(fieldValue) >= amount_1) {
                                formValid = false;
                                this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
                            }
                        }
                        else {
                            if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
                                formValid = false;
                                this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
                            }
                        }
                    }
                }
            }
        }
        return formValid;
    };
    WpbbsaCalculatorService.prototype.validateCalculatorError = function (event, message) {
        if (message === void 0) { message = ''; }
        event.preventDefault();
        var field = event.target;
        //Add error
        if ($(field).closest('.wpbbsa-calculator-form-v2__group').find('p.form__input--field-info').length > 0) {
            var closestGroup = field.closest('.wpbbsa-calculator-form-v2__group');
            $(closestGroup).addClass('wpbbsa-calculator-form-v2__error');
        }
        else {
            var fieldDiv = field.closest('div');
            var closestGroup = field.closest('.wpbbsa-calculator-form-v2__group');
            $(fieldDiv).append('<div class="wpbbsa-calculator-form-v2__error-label">' + message + '</div>');
            $(closestGroup).addClass('wpbbsa-calculator-form-v2__error');
        }
    };
    WpbbsaCalculatorService.prototype.validateCalculatorErrorField = function (event, field, message) {
        if (message === void 0) { message = ''; }
        event.preventDefault();
        // Clear errors
        $(field).closest('.wpbbsa-calculator-form-v2__group').removeClass('wpbbsa-calculator-form-v2__error');
        $(field).closest('.wpbbsa-calculator-form-v2__group').find('div.wpbbsa-calculator-form-v2__error-label').remove();
        //Add error
        if ($(field).closest('.wpbbsa-calculator-form-v2__group').find('p.form__input--field-info').length > 0) {
        }
        else {
            var fieldDiv = field.closest('div');
            var closestGroup = field.closest('.wpbbsa-calculator-form-v2__group');
            $(fieldDiv).append('<div class="wpbbsa-calculator-form-v2__error-label">' + message + '</div>');
            $(closestGroup).addClass('wpbbsa-calculator-form-v2__error');
        }
    };
    // RESET VALUES	- OUTPUTS
    WpbbsaCalculatorService.prototype.resetValues = function (form) {
        switch (form.id) {
            case 'wpbbsa-calculator-personal-loans_loan-calculator':
                var output_borrow_hl = document.querySelectorAll('span.js-wpbbsa-calculator-borrow-up-to-hl1');
                var estimate_repayment_hl = document.querySelectorAll('span.js-wpbbsa-calculator-estimated-repayment-hl1');
                var output_borrow_pl = document.querySelectorAll('span.js-wpbbsa-calculator-estimated-repayment-pl1');
                var output_months_pl = document.querySelectorAll('span.js-wpbbsa-calculator-loan-period-pl1');
                var output_date_pl = document.querySelectorAll('span.js-wpbbsa-calculator-first-repayment-date-pl1');
                var output_fees_pl = document.querySelectorAll('span.js-wpbbsa-calculator-total-interest-pl1');
                [].slice.call(output_borrow_pl).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_date_pl).forEach(function (div) {
                    div.innerHTML = '-';
                });
                [].slice.call(output_fees_pl).forEach(function (div) {
                    div.innerHTML = '0';
                });
                break;
            case 'wpbbsa-calculator-vaf':
                var output_estimate_vaf = document.querySelectorAll('span.js-wpbbsa-calculator-estimated-repayment-vaf1');
                var output_total_paid = document.querySelectorAll('span.js-wpbbsa-calculator-total-paid-vaf1');
                [].slice.call(output_estimate_vaf).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_total_paid).forEach(function (div) {
                    div.innerHTML = '0';
                });
                break;
            case 'calculator-vaf_how_much_can_i_afford':
                var output_available_vaf = document.querySelectorAll('span.js-wpbbsa-calculator-available');
                [].slice.call(output_available_vaf).forEach(function (div) {
                    div.innerHTML = '0';
                });
                break;
            case 'calculator-vaf_finance_calculator':
                var output_amount_vaf = document.querySelectorAll('span.js-wpbbsa-calculator-amount-i-can-spend-vaf3');
                [].slice.call(output_amount_vaf).forEach(function (div) {
                    div.innerHTML = '0';
                });
                break;
            case 'wpbbsa-calculator-personal-loans_student-loan-calculator':
                var MONTHLY_PAYMENT_1_STUDENT_NOONE_TEXT_1 = 'Your estimated monthly repayment';
                var MONTHLY_PAYMENT_1_SURETY_TEXT = 'Estimated monthly interest and fees repayment';
                var MONTHLY_PAYMENT_1_SURETY_SUBTEXT = '*To be paid while studying';
                var MONTHLY_PAYMENT_1_NOONE_SUBTEXT = '*To be paid upon completion of studies';
                var MONTHLY_PAYMENT_2_STUDENT_NOONE_TEXT_1 = 'Monthly interest and fees';
                var MONTHLY_PAYMENT_2_SURETY_TEXT = 'Estimated monthly repayments';
                var MONTHLY_PAYMENT_2_SURETY_SUBTEXT = '*To be paid upon completion of studies calculated over a 60 month term';
                var loanamount = form.querySelector('input[name=sl_loan_amount]');
                var loanterm = form.querySelector('input[name=sl_loan_term]');
                var monthlyPaymentFees1Div = document.querySelectorAll('div.js-wpbbsa-calculator-sl-monthly-payment-1--title-data-content');
                var monthlyPaymentFees1 = document.querySelectorAll('span.js-wpbbsa-calculator-sl-monthly-payment-1');
                var monthlyPaymentFees1SubtitleDiv = document.querySelectorAll('span.wpbbsa-calculator-item-v2__subtitle');
                var monthlyPaymentFees2InfoLeft = document.querySelectorAll('div.js-wpbbsa-calculator-sl-monthly-payment-2--title-info-left');
                var monthlyPaymentFees2InfoRight = document.querySelectorAll('span.js-wpbbsa-calculator-sl-monthly-payment-2--value');
                var monthlyPaymentFees2Subinfo = document.querySelectorAll('div.js-wpbbsa-calculator-sl-monthly-payment-2--subinfo');
                if (loanterm) {
                    loanterm.closest('.form__group').classList.remove('form__group--hidden');
                }
                // -- ** DISPLAY TEXT ** -- //
                [].slice.call(monthlyPaymentFees1Div).forEach(function (div) {
                    div.innerHTML = MONTHLY_PAYMENT_1_STUDENT_NOONE_TEXT_1;
                });
                [].slice.call(monthlyPaymentFees1SubtitleDiv).forEach(function (div) {
                    div.classList.add('wpbbsa-calculators-v2__hidden');
                });
                [].slice.call(monthlyPaymentFees1SubtitleDiv).forEach(function (div) {
                    div.innerHTML = '';
                });
                [].slice.call(monthlyPaymentFees2InfoLeft).forEach(function (div) {
                    div.innerHTML = MONTHLY_PAYMENT_2_STUDENT_NOONE_TEXT_1;
                });
                [].slice.call(monthlyPaymentFees2Subinfo).forEach(function (div) {
                    div.classList.add('wpbbsa-calculators-v2__hidden');
                });
                [].slice.call(monthlyPaymentFees2Subinfo).forEach(function (div) {
                    div.innerHTML = '';
                });
                // -- ** DISPLAY TEXT END ** -- //
                // -- ** CALCULATIONS ** -- //
                [].slice.call(monthlyPaymentFees1).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(monthlyPaymentFees2InfoRight).forEach(function (div) {
                    div.innerHTML = '0';
                });
                // -- ** CALCULATIONS END ** -- //
                break;
            default:
                break;
        }
    };
    // -- FORMATTERS -- //
    WpbbsaCalculatorService.prototype.formatNumbers = function (nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ' ' + '$2');
        }
        return x1 + x2;
    };
    WpbbsaCalculatorService.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    WpbbsaCalculatorService.prototype.noalpha = function (input) {
        input.value = input.value.replace(/[^0-9]/g, '');
    };
    WpbbsaCalculatorService.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    WpbbsaCalculatorService.prototype.pmt = function (rate, per, nper, pv, fv) {
        if (rate === void 0) { rate = 0; }
        if (per === void 0) { per = 0; }
        if (nper === void 0) { nper = 0; }
        if (pv === void 0) { pv = 0; }
        if (fv === void 0) { fv = 0; }
        var pmt_value, x;
        if ((per === 0) || (nper === 0)) {
            return 0;
        }
        rate = rate / (per * 100);
        if (rate === 0) {
            pmt_value = -(fv + pv) / nper;
        }
        else {
            x = Math.pow(1 + rate, nper);
            pmt_value = -((rate * (fv + x * pv)) / (-1 + x));
        }
        pmt_value = this.round(pmt_value, 2);
        return pmt_value;
    };
    WpbbsaCalculatorService.prototype.pmt_vaf = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue) {
            futurevalue = 0;
        }
        if (!type) {
            type = 0;
        }
        if (rate === 0) {
            return -(value + futurevalue) / period;
        }
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type === 1) {
            pmt /= (1 + rate);
        }
        return pmt;
    };
    WpbbsaCalculatorService.prototype.nper = function (rate, per, pmt, pv, fv) {
        if (rate === void 0) { rate = 0; }
        if (per === void 0) { per = 0; }
        if (pmt === void 0) { pmt = 0; }
        if (pv === void 0) { pv = 0; }
        if (fv === void 0) { fv = 0; }
        var nper_value;
        if ((per === 0) || (pmt === 0)) {
            return 0;
        }
        rate = rate / (per * 100);
        if (rate === 0) {
            nper_value = -(fv + pv) / pmt;
        }
        else {
            nper_value = Math.log((-fv * rate + pmt) / (pmt + rate * pv)) / Math.log(1 + rate);
        }
        var end = this.round(nper_value, 2);
        return parseFloat(end);
    };
    WpbbsaCalculatorService.prototype.cumipmt = function (amount, rate, term, pmt) {
        if (amount === void 0) { amount = 0; }
        if (rate === void 0) { rate = 0; }
        if (term === void 0) { term = 0; }
        if (pmt === void 0) { pmt = 0; }
        var i, insertedAmount, interestSavings, k, ref, totalInterest, value1, value2, value3;
        totalInterest = 0;
        insertedAmount = amount;
        interestSavings = 0;
        for (i = k = 0, ref = term; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
            value1 = insertedAmount * (rate / 1200);
            value2 = pmt - value1;
            value3 = insertedAmount - value2;
            insertedAmount = value3;
            interestSavings = interestSavings + value1;
        }
        return interestSavings;
    };
    WpbbsaCalculatorService.prototype.cumipmt2 = function (rate, periods, value, start, end, type) {
        if (rate === void 0) { rate = 0; }
        if (periods === void 0) { periods = 0; }
        if (value === void 0) { value = 0; }
        if (start === void 0) { start = 0; }
        if (end === void 0) { end = 0; }
        if (type === void 0) { type = 0; }
        var i, interest, payment;
        payment = this.pmt_cumipmt(rate, periods, value, 0, type);
        interest = 0;
        if (start === 1) {
            if (type === 0) {
                interest = -value;
                start++;
            }
        }
        i = start;
        while (i <= end) {
            if (type === 1) {
                interest += this.fv(rate, i - 2, payment, value, 1) - payment;
            }
            else {
                interest += this.fv(rate, i - 1, payment, value, 0);
            }
            i++;
        }
        interest *= rate;
        return -interest;
    };
    WpbbsaCalculatorService.prototype.fv = function (rate, periods, payment, value, type) {
        if (rate === void 0) { rate = 0; }
        if (periods === void 0) { periods = 0; }
        if (payment === void 0) { payment = 0; }
        if (value === void 0) { value = 0; }
        if (type === void 0) { type = 0; }
        var result, term;
        value = value || 0;
        type = type || 0;
        result = void 0;
        if (rate === 0) {
            result = value + payment * periods;
        }
        else {
            term = Math.pow(1 + rate, periods);
            if (type === 1) {
                result = value * term + payment * (1 + rate) * (term - 1) / rate;
            }
            else {
                result = value * term + payment * (term - 1) / rate;
            }
        }
        return -result;
    };
    WpbbsaCalculatorService.prototype.pmt_cumipmt = function (rate, periods, present, future, type) {
        if (rate === void 0) { rate = 0; }
        if (periods === void 0) { periods = 0; }
        if (present === void 0) { present = 0; }
        if (future === void 0) { future = 0; }
        if (type === void 0) { type = 0; }
        var result, term;
        future = future || 0;
        type = type || 0;
        result = void 0;
        if (rate === 0) {
            result = (present + future) / periods;
        }
        else {
            term = Math.pow(1 + rate, periods);
            if (type === 1) {
                result = (future * rate / (term - 1) + present * rate / (1 - (1 / term))) / (1 + rate);
            }
            else {
                result = future * rate / (term - 1) + present * rate / (1 - (1 / term));
            }
        }
        return -result;
    };
    // -- SIMPLE INTEREST -- //
    WpbbsaCalculatorService.prototype.simpleInterest = function (deposit, term, interest) {
        if (deposit === void 0) { deposit = 0; }
        if (term === void 0) { term = 0; }
        if (interest === void 0) { interest = 10.25; }
        var result = 0;
        var _interest = (interest / 100);
        var _years = (term / 12);
        result = deposit * (1 + (_interest * _years));
        return {
            amount: this.formatter(result)
        };
    };
    // -- COMPOUND INTEREST -- //
    WpbbsaCalculatorService.prototype.compoundInterest = function (deposit, monthlyDeposit, term, interest) {
        if (deposit === void 0) { deposit = 0; }
        if (monthlyDeposit === void 0) { monthlyDeposit = 0; }
        if (term === void 0) { term = 0; }
        if (interest === void 0) { interest = 10.25; }
        var _deposit = parseFloat(deposit);
        var _monthlyDeposit = parseFloat(monthlyDeposit);
        var _term = parseFloat(term);
        var _interest = parseFloat(interest);
        var _intRate = this.round((Math.pow(1 + _interest / 100, 1 / 12) - 1), 3);
        var result = 0;
        for (var a = 0; a < _term; a++) {
            var _int = 0;
            if (a === 0) {
                _int = (_deposit * _intRate);
                result = _deposit;
            }
            else {
                _int = ((result * _intRate) + _monthlyDeposit);
            }
            _int = this.round(_int, 2);
            result = this.round((result + _int), 2);
        }
        return {
            amount: this.formatter(result)
        };
    };
    //WPBBSA AMORTISATION CALCULATOR VALIDATOR FOR ALL FIELDS FOR ANALYTICS
    WpbbsaCalculatorService.prototype.validateWpbbsaCalculatorAllFields = function (allFields, button) {
        var _this = this;
        var dlCalculatorFieldsError = [];
        var formValid = true;
        allFields.forEach(function (element) {
            // varaibles
            var field = element;
            var fieldGroup = field.closest('.wpbbsa-calculator-form-v2__group');
            var fieldValue = field.value;
            var fieldAddon = field;
            var required = field.getAttribute('data-validation-required');
            var title = field.getAttribute('data-validation-title');
            var minimum = parseFloat(field.getAttribute('min'));
            var maximum = parseFloat(field.getAttribute('max'));
            var greaterThan = field.getAttribute('data-validation-greater-than');
            var lessThan = field.getAttribute('data-validation-less-than');
            // removeErrors
            $(field).closest('.wpbbsa-calculator-form-v2__group').removeClass('wpbbsa-calculator-form-v2__error');
            $(field).closest('.wpbbsa-calculator-form-v2__group').find('div.wpbbsa-calculator-form-v2__error-label').remove();
            if (fieldGroup && !fieldGroup.classList.contains('wpbbsa-calculator-form-v2__hidden')) {
                // required
                if (required == "true") {
                    if (field.type == "text" || field.type == "number" || field.type == "select" || field.type == "select-one") {
                        if (fieldValue.length == 0 || fieldValue == "" || fieldValue == null) {
                            if ($(field).closest('.wpbbsa-calculator-form-v2__group').find('p.form__input--field-info').length > 0) {
                                formValid = false;
                                _this.validateWpbbsaCalculatorErrorAllFields(field, '', dlCalculatorFieldsError);
                            }
                            else {
                                formValid = false;
                                _this.validateWpbbsaCalculatorErrorAllFields(field, 'This field is required', dlCalculatorFieldsError);
                            }
                        }
                    }
                    else if (fieldValue.length == 0) {
                        formValid = false;
                        if ($(field).closest('.wpbbsa-calculator-form-v2__group').find('p.form__input--field-info').length > 0) {
                        }
                        else {
                            if (minimum) {
                                if (maximum) {
                                    if (title) {
                                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum) + ' ' + title, dlCalculatorFieldsError);
                                    }
                                    else {
                                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum), dlCalculatorFieldsError);
                                    }
                                }
                                else {
                                    _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount', dlCalculatorFieldsError);
                                }
                            }
                            else {
                                _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount', dlCalculatorFieldsError);
                            }
                        }
                    }
                }
                //check date
                if (field.type == "text" && field.classList.contains('form__datepicker')) {
                    if (fieldValue != "" && fieldValue != null) {
                        var date = new Date(fieldValue);
                        if (date.toString().toUpperCase() == "INVALID DATE" || isNaN(Date.parse(fieldValue))) {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Invalid date', dlCalculatorFieldsError);
                        }
                        else if (date > new Date()) {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Cannot use selected date', dlCalculatorFieldsError);
                        }
                    }
                }
                // check text field
                if ((field.type == "text" || field.type == "number") && !field.classList.contains('form__datepicker')) {
                    if (fieldValue != "" && fieldValue != null) {
                        var numberValue = new RegExp('^[-+]?[0-9]*\.?[0-9]+$');
                        if (!numberValue.test(fieldValue)) {
                            if ($(field).closest('.wpbbsa-calculator-form-v2__group').find('p.form__input--field-info').length > 0) {
                                formValid = false;
                                _this.validateWpbbsaCalculatorErrorAllFields(field, '', dlCalculatorFieldsError);
                            }
                            else {
                                formValid = false;
                                _this.validateWpbbsaCalculatorErrorAllFields(field, 'Please enter only numbers', dlCalculatorFieldsError);
                            }
                        }
                        else {
                            // min
                            if (minimum > parseFloat(fieldValue)) {
                                formValid = false;
                                if ($(field).closest('.wpbbsa-calculator-form-v2__group').find('p.form__input--field-info').length > 0) {
                                    _this.validateWpbbsaCalculatorErrorAllFields(field, '', dlCalculatorFieldsError);
                                }
                                else {
                                    if (title && maximum) {
                                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum) + ' ' + title, dlCalculatorFieldsError);
                                    }
                                    else if (!title && maximum) {
                                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum), dlCalculatorFieldsError);
                                    }
                                    else if (!title && !maximum) {
                                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount', dlCalculatorFieldsError);
                                    }
                                }
                            }
                            // max
                            if (maximum > 0) {
                                if (maximum < parseFloat(fieldValue)) {
                                    formValid = false;
                                    if ($(field).closest('.wpbbsa-calculator-form-v2__group').find('p.form__input--field-info').length > 0) {
                                        _this.validateWpbbsaCalculatorErrorAllFields(field, '', dlCalculatorFieldsError);
                                    }
                                    else {
                                        if (title) {
                                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum) + ' ' + title, dlCalculatorFieldsError);
                                        }
                                        else {
                                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum), dlCalculatorFieldsError);
                                        }
                                    }
                                }
                            }
                            else {
                                if (maximum < parseFloat(fieldValue)) {
                                    formValid = false;
                                    if ($(field).closest('.wpbbsa-calculator-form-v2__group').find('p.form__input--field-info').length > 0) {
                                        _this.validateWpbbsaCalculatorErrorAllFields(field, '', dlCalculatorFieldsError);
                                    }
                                    else {
                                        if (title) {
                                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'The maximum you can insert is 0 ' + title, dlCalculatorFieldsError);
                                        }
                                        else {
                                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'The maximum you can insert is 0', dlCalculatorFieldsError);
                                        }
                                    }
                                }
                            }
                            // greater than
                            if (greaterThan) {
                                var fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
                                if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
                                    formValid = false;
                                    if ($(field).closest('.wpbbsa-calculator-form-v2__group').find('p.form__input--field-info').length > 0) {
                                        _this.validateWpbbsaCalculatorErrorAllFields(field, '', dlCalculatorFieldsError);
                                    }
                                    else {
                                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount greater than the expenses field', dlCalculatorFieldsError);
                                    }
                                }
                            }
                            // less than
                            if (lessThan) {
                                var fieldsLessThan = $(field).closest('form').find('input[name=' + lessThan + ']');
                                if (fieldsLessThan.length > 1) {
                                    var amount_2 = 0;
                                    $(fieldsLessThan).each(function (index) {
                                        var valueElement = $(this).val();
                                        if (!valueElement) {
                                            amount_2 = amount_2 + 0;
                                        }
                                        else {
                                            amount_2 = amount_2 + parseFloat(valueElement);
                                        }
                                    });
                                    if (parseFloat(fieldValue) >= amount_2) {
                                        formValid = false;
                                        if ($(field).closest('.wpbbsa-calculator-form-v2__group').find('p.form__input--field-info').length > 0) {
                                            _this.validateWpbbsaCalculatorErrorAllFields(field, '', dlCalculatorFieldsError);
                                        }
                                        else {
                                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount (expenses may not exceed total income)', dlCalculatorFieldsError);
                                        }
                                    }
                                }
                                else {
                                    if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
                                        formValid = false;
                                        if ($(field).closest('.wpbbsa-calculator-form-v2__group').find('p.form__input--field-info').length > 0) {
                                            _this.validateWpbbsaCalculatorErrorAllFields(field, '', dlCalculatorFieldsError);
                                        }
                                        else {
                                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount (expenses may not exceed total income)', dlCalculatorFieldsError);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
        //If we have any errors on client side, trigger analytics to record all fields
        if (dlCalculatorFieldsError.length) {
            this.analyticsService.dtmFormFieldsValidationFail(dlCalculatorFieldsError.join(','));
        }
        return formValid;
    };
    WpbbsaCalculatorService.prototype.validateWpbbsaCalculatorErrorAllFields = function (field, message, dlCalculatorFieldsError) {
        if (message === void 0) { message = ''; }
        var closestGroup = field.closest('.wpbbsa-calculator-form-v2__group');
        $(closestGroup).addClass('wpbbsa-calculator-form-v2__error').append('<div class="wpbbsa-calculator-form-v2__error-label">' + message + '</div>');
        // Analytics - ensure that the field name is not already in the log
        if (field.name && dlCalculatorFieldsError.indexOf(field.name) < 0) {
            dlCalculatorFieldsError.push(field.name);
        }
    };
    return WpbbsaCalculatorService;
}());
export { WpbbsaCalculatorService };
// ** AMORTISATION CALCULATOR DATA ** //
var WpbbsaCalculatorPersonalloansAmortisation = /** @class */ (function () {
    function WpbbsaCalculatorPersonalloansAmortisation() {
        this.formValid = true;
        this.isMobileView = false;
        this.isMobileCalculate = false;
        this.numberOfAdditionalPayments = 0;
        this.numberOfMissedPayments = 0;
        this.numberOfRevolves = 0;
        this.monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
    }
    WpbbsaCalculatorPersonalloansAmortisation.prototype.bindEvents = function () {
        var _this = this;
        this.calculatorSubmit.addEventListener("click", function (event) {
            _this.inputs = Array.from(_this.calculatorForm.querySelectorAll("input, select"));
            _this.amortisationTableLabel.innerHTML =
                "No information to display.";
            var btnViewPayments = Array.from(_this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-view-payments"));
            _this.formValid = _this.wpbbsaCalculatorService.validateWpbbsaCalculatorAllFields(_this.inputs, _this.calculatorSubmit);
            var _valid = Array.from(_this.calculatorForm.querySelectorAll('.wpbbsa-calculator-form-v2__error'));
            if (_this.formValid && _valid.length <= 0) {
                // Do calculations
                _this.doCalcs(_this.calculatorForm);
                // Analytics - Trigger form Complete when the user calculates the results
                _this.analyticsService.dtmFormComplete("complete", "");
                // animate back to top and display mobile calculations
                if ($(window).width() < 768) {
                    _this.isMobileCalculate = true;
                    _this.checkIfMobile();
                    // top of calculator information
                    $('html,body').animate({
                        scrollTop: $(_this.calculatorInfo).offset().top - 100
                    }, 'slow');
                }
                else {
                    // top of calculator information
                    $('html,body').animate({
                        scrollTop: $(_this.calculatorMain).offset().top - 40
                    }, 'slow');
                }
            }
            else {
                // Analytics - Trigger form Complete when the user calculates the results
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields| norequest");
                // animate back to top and display mobile calculations
                if ($(window).width() < 768) {
                    _this.isMobileCalculate = false;
                    _this.checkIfMobile();
                    // to first error in calculator form
                    // scroll to error
                    $('html,body').animate({
                        scrollTop: $(_valid[0]).offset().top - 80
                    }, 'slow');
                }
                else {
                    // top of calculator information
                    $('html,body').animate({
                        scrollTop: $(_this.calculatorMain).offset().top - 40
                    }, 'slow');
                }
            }
        });
        this.calculatorReset.addEventListener("click", function (event) {
            var btnViewPayments = Array.from(document.querySelectorAll(".js-wpbbsa-calculator-view-payments"));
            // removeErrors
            $(_this.inputs).closest('.wpbbsa-calculator-form-v2__group').removeClass('wpbbsa-calculator-form-v2__error');
            $(_this.inputs).closest('.wpbbsa-calculator-form-v2__group').find('div.wpbbsa-calculator-form-v2__error-label').remove();
            btnViewPayments.forEach(function (element) {
                element.classList.remove("gradient-orange");
                element.classList.add("button--white");
                element.classList.add("button--border-blue");
            });
            var lblCalculationError = Array.from(document.querySelectorAll("label[name=plua-calculate-calculateError]"));
            lblCalculationError.forEach(function (element) {
                element.innerHTML = "";
            });
            if ($(window).width() > 768) {
                $("html,body").animate({
                    scrollTop: $(_this.calculatorMain)
                        .offset().top
                }, "slow");
            }
            else if ($(window).width() < 768) {
                $("html,body").animate({
                    scrollTop: $(_this.calculatorMain)
                        .offset().top - 80,
                }, "slow");
            }
            _this.resetValues();
        });
        this.sliders.map(function (item) { return item.addEventListener('input', function (event) {
            _this.updateSlider(event);
        }); });
        if (this.loanTypeSelect) {
            this.loanTypeSelect.addEventListener("change", function (event) {
                if (_this.loanTypeSelect.value === "TERM LOAN") {
                    _this.dataHtmlCollection.forEach(function (item, index) {
                        if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-first") != -1) {
                            //item.classList.remove("hidden");
                            var itemParent = item.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                            itemParent.classList.remove("wpbbsa-calculators-v2__hidden");
                        }
                        if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-second") != -1) {
                            // item.classList.add("hidden");
                            var itemParent = item.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                            itemParent.classList.add("wpbbsa-calculators-v2__hidden");
                        }
                    });
                }
                else {
                    _this.dataHtmlCollection.forEach(function (item, index) {
                        if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-first") != -1) {
                            // item.classList.add("hidden");
                            var itemParent = item.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                            itemParent.classList.add("wpbbsa-calculators-v2__hidden");
                        }
                        if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-second") != -1) {
                            // item.classList.remove("hidden");
                            var itemParent = item.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                            itemParent.classList.remove("wpbbsa-calculators-v2__hidden");
                        }
                    });
                }
                _this.updateFormLoanType(_this.loanTypeSelect.value);
            });
        }
        if (this.madeAdditionalPayments) {
            this.madeAdditionalPayments.addEventListener("change", function (event) {
                _this.updateMadeAnAdditionalPayment(_this.madeAdditionalPayments.checked);
            });
        }
        if (this.addAdditionalPaymentBtn) {
            this.addAdditionalPaymentBtn.addEventListener("click", function (event) {
                _this.addAdditionalPayment();
            });
        }
        if (this.removeAdditionalPaymentBtn) {
            this.removeAdditionalPaymentBtn.addEventListener("click", function (event) {
                _this.removeAdditionalPayment();
            });
        }
        if (this.haveMissedPayments) {
            this.haveMissedPayments.addEventListener("change", function (event) {
                _this.updateHaveMissedPayment(_this.haveMissedPayments.checked);
            });
        }
        if (this.addMissedPaymentBtn) {
            this.addMissedPaymentBtn.addEventListener("click", function (event) {
                _this.addMissedPayment();
            });
        }
        if (this.removeMissedPaymentBtn) {
            this.removeMissedPaymentBtn.addEventListener("click", function (event) {
                _this.removeMissedPayment();
            });
        }
        if (this.revolved) {
            this.revolved.addEventListener("change", function (event) {
                _this.updateRevolved(_this.revolved.checked);
            });
        }
        if (this.addRevolvedBtn) {
            this.addRevolvedBtn.addEventListener("click", function (event) {
                _this.addRevolved();
            });
        }
        if (this.removeRevolvedBtn) {
            this.removeRevolvedBtn.addEventListener("click", function (event) {
                _this.removeRevolved();
            });
        }
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.updateFormLoanType = function (loanType) {
        this.loanType = loanType;
        if (loanType === "TERM LOAN") {
            this.loanTypeFormTitle.innerHTML = "Loan amount";
            this.loanTypeTitle.innerHTML = "Loan amount";
            this.loanTypeFormStartDateTitle.innerHTML = "Loan start date";
            this.loanTypeStartDateTitle.innerHTML = "Loan start date";
            var _revolvedGroup = this.revolved.closest(".wpbbsa-calculator-form-v2__group-parent-div");
            _revolvedGroup.classList.add("wpbbsa-calculators-v2__hidden");
            var termLoanInsuranceType = this.calculatorForm.querySelector("select[name=term-loan-insurance-type]");
            var revolvingLoanInsuranceType = this.calculatorForm.querySelector("select[name=revolving-loan-insurance-type]");
            var _termLoanInsuranceTypeGroup = termLoanInsuranceType.closest(".wpbbsa-calculator-form-v2__group-parent-div");
            var _revolvingLoanInsuranceTypeGroup = revolvingLoanInsuranceType.closest(".wpbbsa-calculator-form-v2__group-parent-div");
            revolvingLoanInsuranceType.removeAttribute("data-validation-required");
            _revolvingLoanInsuranceTypeGroup.classList.add("wpbbsa-calculators-v2__hidden");
            _termLoanInsuranceTypeGroup.classList.remove("wpbbsa-calculators-v2__hidden");
            termLoanInsuranceType.setAttribute("data-validation-required", "true");
            this.updateRevolved(false);
        }
        else if (loanType === "REVOLVING LOAN - NO LIMIT CHANGE") {
            this.loanTypeFormTitle.innerHTML = "Loan amount";
            this.loanTypeTitle.innerHTML = "Loan amount";
            this.loanTypeFormStartDateTitle.innerHTML = "Loan start date";
            this.loanTypeStartDateTitle.innerHTML = "Loan start date";
            var _revolvedGroup = this.revolved.closest(".wpbbsa-calculator-form-v2__group-parent-div");
            _revolvedGroup.classList.remove("wpbbsa-calculators-v2__hidden");
            var termLoanInsuranceType = this.calculatorForm.querySelector("select[name=term-loan-insurance-type]");
            var revolvingLoanInsuranceType = this.calculatorForm.querySelector("select[name=revolving-loan-insurance-type]");
            var _termLoanInsuranceTypeGroup = termLoanInsuranceType.closest(".wpbbsa-calculator-form-v2__group-parent-div");
            var _revolvingLoanInsuranceTypeGroup = revolvingLoanInsuranceType.closest(".wpbbsa-calculator-form-v2__group-parent-div");
            termLoanInsuranceType.removeAttribute("data-validation-required");
            _termLoanInsuranceTypeGroup.classList.add("wpbbsa-calculators-v2__hidden");
            _revolvingLoanInsuranceTypeGroup.classList.remove("wpbbsa-calculators-v2__hidden");
            revolvingLoanInsuranceType.setAttribute("data-validation-required", "true");
        }
        else if (loanType === "REVOLVING LOAN - LIMIT CHANGE") {
            this.loanTypeFormTitle.innerHTML = "Recently changed limit";
            this.loanTypeTitle.innerHTML = "Recently changed limit";
            this.loanTypeFormStartDateTitle.innerHTML =
                "Last limit increase date";
            this.loanTypeStartDateTitle.innerHTML = "Last limit increase date";
            var _revolvedGroup = this.revolved.closest(".wpbbsa-calculator-form-v2__group-parent-div");
            _revolvedGroup.classList.remove("wpbbsa-calculators-v2__hidden");
            var termLoanInsuranceType = this.calculatorForm.querySelector("select[name=term-loan-insurance-type]");
            var revolvingLoanInsuranceType = this.calculatorForm.querySelector("select[name=revolving-loan-insurance-type]");
            var _termLoanInsuranceTypeGroup = termLoanInsuranceType.closest(".wpbbsa-calculator-form-v2__group-parent-div");
            var _revolvingLoanInsuranceTypeGroup = revolvingLoanInsuranceType.closest(".wpbbsa-calculator-form-v2__group-parent-div");
            termLoanInsuranceType.removeAttribute("data-validation-required");
            _termLoanInsuranceTypeGroup.classList.add("wpbbsa-calculators-v2__hidden");
            _revolvingLoanInsuranceTypeGroup.classList.remove("wpbbsa-calculators-v2__hidden");
            revolvingLoanInsuranceType.setAttribute("data-validation-required", "true");
        }
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.updateMadeAnAdditionalPayment = function (madeAnAdditionalPayment) {
        if (this.additionalPaymentItems) {
            if (madeAnAdditionalPayment) {
                if (this.numberOfAdditionalPayments === 0) {
                    this.addAdditionalPayment();
                }
                var additionalPaymentItemsChildren = this.additionalPaymentItems.querySelectorAll(".wpbbsa-calculator-form-v2__group");
                additionalPaymentItemsChildren.forEach(function (elem) {
                    elem.classList.remove("wpbbsa-calculator-form-v2__hidden");
                });
                var additionalPaymentItemsParent = this.additionalPaymentItems.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                additionalPaymentItemsParent.classList.remove("wpbbsa-calculators-v2__hidden");
                var addRemoveAdditionalPaymentsParent = this.addRemoveAdditionalPayments.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                addRemoveAdditionalPaymentsParent.classList.remove("wpbbsa-calculators-v2__hidden");
            }
            else {
                var additionalPaymentItemsChildren = this.additionalPaymentItems.querySelectorAll(".wpbbsa-calculator-form-v2__group");
                additionalPaymentItemsChildren.forEach(function (elem) {
                    elem.classList.add("wpbbsa-calculator-form-v2__hidden");
                });
                var additionalPaymentItemsParent = this.additionalPaymentItems.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                additionalPaymentItemsParent.classList.add("wpbbsa-calculators-v2__hidden");
                var addRemoveAdditionalPaymentsParent = this.addRemoveAdditionalPayments.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                addRemoveAdditionalPaymentsParent.classList.add("wpbbsa-calculators-v2__hidden");
            }
        }
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.updateHaveMissedPayment = function (haveMissedPayment) {
        if (this.missedPaymentItems) {
            if (haveMissedPayment) {
                if (this.numberOfMissedPayments === 0) {
                    this.addMissedPayment();
                }
                var missedPaymentItemsChildren = this.missedPaymentItems.querySelectorAll(".wpbbsa-calculator-form-v2__group");
                missedPaymentItemsChildren.forEach(function (elem) {
                    elem.classList.remove("wpbbsa-calculator-form-v2__hidden");
                });
                var missedPaymentItemsParent = this.missedPaymentItems.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                missedPaymentItemsParent.classList.remove("wpbbsa-calculators-v2__hidden");
                var addRemoveMissedPaymentsParent = this.addRemoveMissedPayments.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                addRemoveMissedPaymentsParent.classList.remove("wpbbsa-calculators-v2__hidden");
            }
            else {
                var missedPaymentItemsChildren = this.missedPaymentItems.querySelectorAll(".wpbbsa-calculator-form-v2__group");
                missedPaymentItemsChildren.forEach(function (elem) {
                    elem.classList.add("wpbbsa-calculator-form-v2__hidden");
                });
                var missedPaymentItemsParent = this.missedPaymentItems.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                missedPaymentItemsParent.classList.add("wpbbsa-calculators-v2__hidden");
                var addRemoveMissedPaymentsParent = this.addRemoveMissedPayments.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                addRemoveMissedPaymentsParent.classList.add("wpbbsa-calculators-v2__hidden");
            }
        }
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.updateRevolved = function (revolved) {
        if (this.revolvedItems) {
            if (revolved) {
                if (this.numberOfRevolves === 0) {
                    this.addRevolved();
                }
                var revolvedItemsChildren = this.revolvedItems.querySelectorAll(".wpbbsa-calculator-form-v2__group");
                revolvedItemsChildren.forEach(function (elem) {
                    elem.classList.remove("wpbbsa-calculator-form-v2__hidden");
                });
                var revolvedItemsParent = this.revolvedItems.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                revolvedItemsParent.classList.remove("wpbbsa-calculators-v2__hidden");
                var addRemoveRevolvedParent = this.addRemoveRevolves.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                addRemoveRevolvedParent.classList.remove("wpbbsa-calculators-v2__hidden");
                // this.revolvedEmptySpaceDiv.classList.remove("wpbbsa-calculators-v2__hidden");
            }
            else {
                var revolvedItemsChildren = this.revolvedItems.querySelectorAll(".wpbbsa-calculator-form-v2__group");
                revolvedItemsChildren.forEach(function (elem) {
                    elem.classList.add("wpbbsa-calculator-form-v2__hidden");
                });
                var revolvedItemsParent = this.revolvedItems.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                revolvedItemsParent.classList.add("wpbbsa-calculators-v2__hidden");
                var addRemoveRevolvedParent = this.addRemoveRevolves.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                addRemoveRevolvedParent.classList.add("wpbbsa-calculators-v2__hidden");
                // this.revolvedEmptySpaceDiv.classList.add("wpbbsa-calculators-v2__hidden");
            }
        }
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.addAdditionalPayment = function () {
        if (this.numberOfAdditionalPayments <= 20) {
            this.numberOfAdditionalPayments++;
            var addAdditionalPaymentDetailsDiv = document.createElement("div");
            addAdditionalPaymentDetailsDiv.classList.add("row", "additionalPaymentItem-" + this.numberOfAdditionalPayments);
            var additionalPaymentGroupParent1 = document.createElement('div');
            additionalPaymentGroupParent1.classList.add("col", "col-12", "col-md-6");
            var additionalPaymentGroupParent2 = document.createElement('div');
            additionalPaymentGroupParent2.classList.add("col", "col-12", "col-md-6");
            var additionalPaymentDateGroup = document.createElement("div");
            additionalPaymentDateGroup.classList.add("form__group", "wpbbsa-calculator-form-v2__group", "amortisation-add-remove-group");
            var additionalPaymentDateLabel = document.createElement("label");
            additionalPaymentDateLabel.setAttribute("for", "date-of-additional-payment-" + this.numberOfAdditionalPayments);
            additionalPaymentDateLabel.classList.add("form__label", "wpbbsa-calculator-form-v2__label");
            additionalPaymentDateLabel.textContent = "Date of Additional Payment " + this.numberOfAdditionalPayments;
            additionalPaymentDateGroup.appendChild(additionalPaymentDateLabel);
            var additionalPaymentDateInputRow = document.createElement("div");
            additionalPaymentDateInputRow.classList.add("row", "no-gutters");
            var additionalPaymentDateInputCol = document.createElement("div");
            additionalPaymentDateInputCol.classList.add("col", "col-12");
            var additionalPaymentDateInput = document.createElement("input");
            additionalPaymentDateInput.type = "text";
            additionalPaymentDateInput.name = "date-of-additional-payment-" + this.numberOfAdditionalPayments;
            additionalPaymentDateInput.value = "";
            additionalPaymentDateInput.placeholder = "Select date",
                additionalPaymentDateInput.classList.add("form__input", "wpbbsa-calculator-form-v2__input", "form__input--required", "form__input--date", "js-date-picker-full", "form__datepicker", "dynamicElement");
            additionalPaymentDateInput.setAttribute("data-validation-required", "true");
            additionalPaymentDateInputCol.appendChild(additionalPaymentDateInput);
            additionalPaymentDateInputRow.appendChild(additionalPaymentDateInputCol);
            additionalPaymentDateGroup.appendChild(additionalPaymentDateInputRow);
            var additionalPaymentAmountGroup = document.createElement("div");
            additionalPaymentAmountGroup.classList.add("form__group", "wpbbsa-calculator-form-v2__group", "amortisation-add-remove-group");
            var additionalPaymentAmountLabel = document.createElement("label");
            additionalPaymentAmountLabel.setAttribute("for", "amount-of-additional-payment-" + this.numberOfAdditionalPayments);
            additionalPaymentAmountLabel.classList.add("form__label", "wpbbsa-calculator-form-v2__label");
            additionalPaymentAmountLabel.textContent = "Additional Payment Amount " + this.numberOfAdditionalPayments;
            additionalPaymentAmountGroup.appendChild(additionalPaymentAmountLabel);
            var additionalPaymentAmountInputRow = document.createElement("div");
            additionalPaymentAmountInputRow.classList.add("row", "no-gutters");
            var additionalPaymentAmountInputCol = document.createElement("div");
            additionalPaymentAmountInputCol.classList.add("col", "col-12");
            var additionalPaymentAmountInput = document.createElement("input");
            additionalPaymentAmountInput.type = "number";
            additionalPaymentAmountInput.name = "amount-of-additional-payment-" + this.numberOfAdditionalPayments;
            additionalPaymentAmountInput.value = "";
            additionalPaymentAmountInput.placeholder = '0';
            additionalPaymentAmountInput.classList.add("form-control", "form__input", "wpbbsa-calculator-form-v2__input", "wpbbsa-calculator-form-v2__input--icon-currency-left", "form__input--number", "dynamicElement");
            additionalPaymentAmountInput.setAttribute("step", "1");
            additionalPaymentAmountInput.setAttribute("min", "1");
            additionalPaymentAmountInput.setAttribute("data-value", "");
            additionalPaymentAmountInput.setAttribute("maxlength", "10");
            additionalPaymentAmountInput.setAttribute("data-validation-required", "true");
            additionalPaymentAmountInput.setAttribute("placeholder", "0");
            additionalPaymentAmountInputCol.appendChild(additionalPaymentAmountInput);
            additionalPaymentAmountInputRow.appendChild(additionalPaymentAmountInputCol);
            additionalPaymentAmountGroup.appendChild(additionalPaymentAmountInputRow);
            addAdditionalPaymentDetailsDiv.appendChild(additionalPaymentDateGroup);
            addAdditionalPaymentDetailsDiv.appendChild(additionalPaymentAmountGroup);
            additionalPaymentGroupParent1.appendChild(additionalPaymentDateGroup);
            additionalPaymentGroupParent2.appendChild(additionalPaymentAmountGroup);
            addAdditionalPaymentDetailsDiv.appendChild(additionalPaymentGroupParent1);
            addAdditionalPaymentDetailsDiv.appendChild(additionalPaymentGroupParent2);
            this.additionalPaymentItems.appendChild(addAdditionalPaymentDetailsDiv);
            this.wpbbsaCalculatorService.initializeDatePickers();
        }
        this.updateAddRemoveAdditionalPayments();
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.removeAdditionalPayment = function () {
        if (this.numberOfAdditionalPayments >= 1) {
            var lastAdditionalPayment = this.calculatorForm.querySelector(".additionalPaymentItem-" + this.numberOfAdditionalPayments);
            lastAdditionalPayment.parentElement.removeChild(lastAdditionalPayment);
            this.numberOfAdditionalPayments--;
        }
        this.updateAddRemoveAdditionalPayments();
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.updateAddRemoveAdditionalPayments = function () {
        if (this.numberOfAdditionalPayments >= 20) {
            this.addAdditionalPaymentDiv.classList.add("wpbbsa-calculators-v2__hidden");
        }
        else {
            this.addAdditionalPaymentDiv.classList.remove("wpbbsa-calculators-v2__hidden");
        }
        if (this.numberOfAdditionalPayments <= 1) {
            this.removeAdditionalPaymentDiv.classList.add("wpbbsa-calculators-v2__hidden");
        }
        else {
            this.removeAdditionalPaymentDiv.classList.remove("wpbbsa-calculators-v2__hidden");
        }
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.addMissedPayment = function () {
        if (this.numberOfMissedPayments <= 20) {
            this.numberOfMissedPayments++;
            var addMissedPaymentDetailsDiv = document.createElement("div");
            addMissedPaymentDetailsDiv.classList.add("row", "missedPaymentItem-" + this.numberOfMissedPayments);
            var missedPaymentGroupParent1 = document.createElement('div');
            missedPaymentGroupParent1.classList.add("col", "col-12", "col-md-6");
            var missedPaymentGroupParent2 = document.createElement('div');
            missedPaymentGroupParent2.classList.add("col", "col-12", "col-md-6");
            var missedPaymentDateGroup = document.createElement("div");
            missedPaymentDateGroup.classList.add("form__group", "wpbbsa-calculator-form-v2__group", "amortisation-add-remove-group");
            var missedPaymentDateLabel = document.createElement("label");
            missedPaymentDateLabel.setAttribute("for", "date-of-missed-payment-" + this.numberOfMissedPayments);
            missedPaymentDateLabel.classList.add("form__label", "wpbbsa-calculator-form-v2__label");
            missedPaymentDateLabel.textContent = "Date of Missed Payment " + this.numberOfMissedPayments;
            missedPaymentDateGroup.appendChild(missedPaymentDateLabel);
            var missedPaymentDateInputRow = document.createElement("div");
            missedPaymentDateInputRow.classList.add("row", "no-gutters");
            var missedPaymentDateInputCol = document.createElement("div");
            missedPaymentDateInputCol.classList.add("col", "col-12");
            var missedPaymentDateInput = document.createElement("input");
            missedPaymentDateInput.type = "text";
            missedPaymentDateInput.name = "date-of-missed-payment-" + this.numberOfMissedPayments;
            missedPaymentDateInput.value = "";
            missedPaymentDateInput.placeholder = "Select date",
                missedPaymentDateInput.classList.add("form__input", "wpbbsa-calculator-form-v2__input", "form__input--required", "form__input--date", "js-date-picker-full", "form__datepicker", "dynamicElement");
            missedPaymentDateInput.setAttribute("data-validation-required", "true");
            var _emptyDiv = document.createElement('p');
            missedPaymentDateInputCol.appendChild(missedPaymentDateInput);
            missedPaymentDateInputRow.appendChild(missedPaymentDateInputCol);
            missedPaymentDateGroup.appendChild(missedPaymentDateInputRow);
            // addMissedPaymentDetailsDiv.appendChild(missedPaymentDateGroup);
            missedPaymentGroupParent1.appendChild(missedPaymentDateGroup);
            missedPaymentGroupParent2.appendChild(_emptyDiv);
            addMissedPaymentDetailsDiv.appendChild(missedPaymentGroupParent1);
            addMissedPaymentDetailsDiv.appendChild(missedPaymentGroupParent2);
            this.missedPaymentItems.appendChild(addMissedPaymentDetailsDiv);
            this.wpbbsaCalculatorService.initializeDatePickers();
        }
        this.updateAddRemoveMissedPayments();
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.removeMissedPayment = function () {
        if (this.numberOfMissedPayments >= 1) {
            var lastMissedPayment = this.calculatorForm.querySelector(".missedPaymentItem-" + this.numberOfMissedPayments);
            lastMissedPayment.parentElement.removeChild(lastMissedPayment);
            this.numberOfMissedPayments--;
        }
        this.updateAddRemoveMissedPayments();
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.updateAddRemoveMissedPayments = function () {
        if (this.numberOfMissedPayments >= 20) {
            this.addMissedPaymentDiv.classList.add("wpbbsa-calculators-v2__hidden");
        }
        else {
            this.addMissedPaymentDiv.classList.remove("wpbbsa-calculators-v2__hidden");
        }
        if (this.numberOfMissedPayments <= 1) {
            this.removeMissedPaymentDiv.classList.add("wpbbsa-calculators-v2__hidden");
        }
        else {
            this.removeMissedPaymentDiv.classList.remove("wpbbsa-calculators-v2__hidden");
        }
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.addRevolved = function () {
        if (this.numberOfRevolves <= 20) {
            this.numberOfRevolves++;
            var addRevolveDetailsDiv = document.createElement("div");
            addRevolveDetailsDiv.classList.add("row", "revolvedItem-" + this.numberOfRevolves);
            var revolvedGroupParent1 = document.createElement('div');
            revolvedGroupParent1.classList.add("col", "col-12", "col-md-6");
            var revolvedGroupParent2 = document.createElement('div');
            revolvedGroupParent2.classList.add("col", "col-12", "col-md-6");
            var revolvedDateGroup = document.createElement("div");
            revolvedDateGroup.classList.add("form__group", "wpbbsa-calculator-form-v2__group", "amortisation-add-remove-group");
            var revolvedDateLabel = document.createElement("label");
            revolvedDateLabel.setAttribute("for", "date-of-revolved-" + this.numberOfRevolves);
            revolvedDateLabel.classList.add("form__label", "wpbbsa-calculator-form-v2__label");
            revolvedDateLabel.textContent = "Date Revolved " + this.numberOfRevolves;
            revolvedDateGroup.appendChild(revolvedDateLabel);
            var revolvedDateInputRow = document.createElement("div");
            revolvedDateInputRow.classList.add("row", "no-gutters");
            var revolvedDateInputCol = document.createElement("div");
            revolvedDateInputCol.classList.add("col", "col-12");
            var revolvedDateInput = document.createElement("input");
            revolvedDateInput.type = "text";
            revolvedDateInput.name = "date-of-revolved-" + this.numberOfRevolves;
            revolvedDateInput.value = "";
            revolvedDateInput.placeholder = "Select date",
                revolvedDateInput.classList.add("form__input", "wpbbsa-calculator-form-v2__input", "form__input--required", "form__input--date", "js-date-picker-full", "form__datepicker", "dynamicElement");
            revolvedDateInput.setAttribute("data-validation-required", "true");
            revolvedDateInputCol.appendChild(revolvedDateInput);
            revolvedDateInputRow.appendChild(revolvedDateInputCol);
            revolvedDateGroup.appendChild(revolvedDateInputRow);
            var revolvedAmountGroup = document.createElement("div");
            revolvedAmountGroup.classList.add("form__group", "wpbbsa-calculator-form-v2__group", "amortisation-add-remove-group");
            var revolvedAmountLabel = document.createElement("label");
            revolvedAmountLabel.setAttribute("for", "amount-of-revolved-" + this.numberOfRevolves);
            revolvedAmountLabel.classList.add("form__label", "wpbbsa-calculator-form-v2__label");
            revolvedAmountLabel.textContent = "Revolve Amount " + this.numberOfRevolves;
            revolvedAmountGroup.appendChild(revolvedAmountLabel);
            var revolvedAmountInputRow = document.createElement("div");
            revolvedAmountInputRow.classList.add("row", "no-gutters");
            var revolvedAmountInputCol = document.createElement("div");
            revolvedAmountInputCol.classList.add("col", "col-12");
            var revolvedAmountInput = document.createElement("input");
            revolvedAmountInput.type = "number";
            revolvedAmountInput.name = "amount-of-revolved-" + this.numberOfRevolves;
            revolvedAmountInput.value = "";
            revolvedAmountInput.placeholder = '0';
            revolvedAmountInput.classList.add("form-control", "form__input", "wpbbsa-calculator-form-v2__input", "wpbbsa-calculator-form-v2__input--icon-currency-left", "form__input--number", "dynamicElement");
            revolvedAmountInput.setAttribute("step", "1");
            revolvedAmountInput.setAttribute("min", "1");
            revolvedAmountInput.setAttribute("data-value", "");
            revolvedAmountInput.setAttribute("maxlength", "10");
            revolvedAmountInput.setAttribute("data-validation-required", "true");
            revolvedAmountInput.setAttribute("placeholder", "0");
            revolvedAmountInputCol.appendChild(revolvedAmountInput);
            revolvedAmountInputRow.appendChild(revolvedAmountInputCol);
            revolvedAmountGroup.appendChild(revolvedAmountInputRow);
            revolvedGroupParent1.appendChild(revolvedDateGroup);
            revolvedGroupParent2.appendChild(revolvedAmountGroup);
            addRevolveDetailsDiv.appendChild(revolvedGroupParent1);
            addRevolveDetailsDiv.appendChild(revolvedGroupParent2);
            // addRevolveDetailsDiv.appendChild(revolvedDateGroup);
            // addRevolveDetailsDiv.appendChild(revolvedAmountGroup);
            this.revolvedItems.appendChild(addRevolveDetailsDiv);
            this.wpbbsaCalculatorService.initializeDatePickers();
        }
        this.updateAddRemoveRevolves();
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.removeRevolved = function () {
        if (this.numberOfRevolves >= 1) {
            var lastRevolve = this.calculatorForm.querySelector(".revolvedItem-" + this.numberOfRevolves);
            lastRevolve.parentElement.removeChild(lastRevolve);
            this.numberOfRevolves--;
        }
        this.updateAddRemoveRevolves();
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.updateAddRemoveRevolves = function () {
        if (this.numberOfRevolves >= 20) {
            this.addRevolvedDiv.classList.add("wpbbsa-calculators-v2__hidden");
        }
        else {
            this.addRevolvedDiv.classList.remove("wpbbsa-calculators-v2__hidden");
        }
        if (this.numberOfRevolves <= 1) {
            this.removeRevolvedDiv.classList.add("wpbbsa-calculators-v2__hidden");
        }
        else {
            this.removeRevolvedDiv.classList.remove("wpbbsa-calculators-v2__hidden");
        }
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.checkIfMobile = function () {
        if ($(window).width() > 768) {
            if (this.calculatorItemElement) {
                $(this.calculatorInfo).removeClass('hidden');
            }
            this.isMobileView = false;
        }
        else {
            if (this.calculatorInfo && this.isMobileCalculate) {
                $(this.calculatorInfo).removeClass('hidden');
            }
            else {
                $(this.calculatorInfo).addClass('hidden');
            }
            this.isMobileView = true;
        }
    };
    // -- CALCULATIONS --
    WpbbsaCalculatorPersonalloansAmortisation.prototype.doCalcs = function (form) {
        // -- Amounts -- //
        var allAdditionalPayments = [];
        var allRevolves = [];
        // -- Dates -- //
        var allAdditionalPaymentDates = [];
        var allMissedPaymentDates = [];
        var allRevolvedDates = [];
        if (this.madeAdditionalPayments.checked) {
            for (var i = 1; i <= this.numberOfAdditionalPayments; i++) {
                var additionalPaymentAmount = form.querySelector("input[name=amount-of-additional-payment-" + i + "]");
                var additionalPaymentDate = form.querySelector("input[name=date-of-additional-payment-" + i + "]");
                allAdditionalPayments.push(Number(additionalPaymentAmount.value));
                allAdditionalPaymentDates.push(new Date(additionalPaymentDate.value));
            }
        }
        if (this.haveMissedPayments.checked) {
            for (var i = 1; i <= this.numberOfMissedPayments; i++) {
                var missedPaymentDate = form.querySelector("input[name=date-of-missed-payment-" + i + "]");
                allMissedPaymentDates.push(new Date(missedPaymentDate.value));
            }
        }
        if (this.revolved.checked) {
            for (var i = 1; i <= this.numberOfRevolves; i++) {
                var revolvedAmount = form.querySelector("input[name=amount-of-revolved-" + i + "]");
                var revolvedDate = form.querySelector("input[name=date-of-revolved-" + i + "]");
                allRevolves.push(Number(revolvedAmount.value));
                allRevolvedDates.push(new Date(revolvedDate.value));
            }
        }
        var loanType = this.loanType;
        if (loanType === "TERM LOAN") {
            var display_calculation_error = this.calculatorItemElement.querySelectorAll("label[name=plua-calculate-calculateError]");
            var display_original_loan_amount = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-loan-amount");
            var display_loan_start_date = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-date-of-loan");
            var display_have_missed_payments_div = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments--div");
            var display_have_missed_payments = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments");
            var display_has_revolved_div = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-has-revolved--div");
            var display_has_revolved = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-has-revolved");
            var display_made_additional_payments_div = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments--div");
            var display_made_additional_payments = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments");
            var display_current_loan_repayment_amount = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-current-loan-repayment-amount");
            var display_correct_loan_repayment_amount = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-correct-loan-repayment-amount");
            var display_amount_of_months_paid_term = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-months-paid");
            var display_loan_term_end_date = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-loan-term-end-date");
            var display_variable_interest_rate = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-variable-interest-rate");
            if (this.haveMissedPayments.checked) {
                for (var i = 0; i < display_have_missed_payments_div.length; i++) {
                    display_have_missed_payments_div[i].classList.remove("wpbbsa-calculators-v2__hidden");
                }
            }
            else {
                for (var i = 0; i < display_have_missed_payments_div.length; i++) {
                    display_have_missed_payments_div[i].classList.add("wpbbsa-calculators-v2__hidden");
                }
            }
            if (this.revolved.checked) {
                for (var i = 0; i < display_has_revolved_div.length; i++) {
                    display_has_revolved_div[i].classList.remove("wpbbsa-calculators-v2__hidden");
                }
            }
            else {
                for (var i = 0; i < display_has_revolved_div.length; i++) {
                    display_has_revolved_div[i].classList.add("wpbbsa-calculators-v2__hidden");
                }
            }
            if (this.madeAdditionalPayments.checked) {
                for (var i = 0; i < display_made_additional_payments_div.length; i++) {
                    display_made_additional_payments_div[i].classList.remove("wpbbsa-calculators-v2__hidden");
                }
            }
            else {
                for (var i = 0; i < display_made_additional_payments_div.length; i++) {
                    display_made_additional_payments_div[i].classList.add("wpbbsa-calculators-v2__hidden");
                }
            }
            var termLoanCalculations_1 = this.doTermLoanCalculations(form, allAdditionalPayments, allAdditionalPaymentDates, allMissedPaymentDates);
            // -- Calculation Error -- //
            [].slice.call(display_calculation_error).forEach(function (label) {
                label.innerHTML = termLoanCalculations_1.calculationErrorMessage;
            });
            // -- Original loan amount -- //
            [].slice.call(display_original_loan_amount).forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.originalLoanAmount;
            });
            // -- Loan start date -- //
            [].slice.call(display_loan_start_date).forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.startDateOfLoan;
            });
            // -- Current loan repayment amount -- //
            [].slice
                .call(display_current_loan_repayment_amount)
                .forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.currentLoanRepayment;
            });
            // -- Correct loan repayment amount -- //
            [].slice
                .call(display_correct_loan_repayment_amount)
                .forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.correctLoanRepayment;
            });
            // -- HAVE MISSED PAYMENTS -- //
            [].slice.call(display_have_missed_payments).forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.haveMissedPaymentsChecked;
            });
            // -- HAS REVOLVED -- //
            [].slice.call(display_has_revolved).forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.hasRevolvedChecked;
            });
            // -- MADE ADDITIONAL PAYMENTS -- //
            [].slice
                .call(display_made_additional_payments)
                .forEach(function (div) {
                div.innerHTML =
                    termLoanCalculations_1.madeAdditionalPaymentsChecked;
            });
            // -- Number of months paid -- //
            [].slice
                .call(display_amount_of_months_paid_term)
                .forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.numberOfMonthsPaid;
            });
            // -- Loan Term end date -- //
            [].slice.call(display_loan_term_end_date).forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.loanTermEndDate;
            });
            // -- Variable Interest Rate -- //
            [].slice
                .call(display_variable_interest_rate)
                .forEach(function (div) {
                div.innerHTML = termLoanCalculations_1.variableInterestRate;
            });
            // -- Amortisation Table -- //
            this.amortisationTableLabel.innerHTML =
                termLoanCalculations_1.amortisationTable;
        }
        else if (loanType === "REVOLVING LOAN - NO LIMIT CHANGE") {
            var display_calculation_error = this.calculatorItemElement.querySelectorAll("label[name=plua-calculate-calculateError]");
            var display_original_loan_amount = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-loan-amount");
            var display_loan_start_date = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-date-of-loan");
            var display_have_missed_payments_div = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments--div");
            var display_have_missed_payments = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments");
            var display_has_revolved_div = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-has-revolved--div");
            var display_has_revolved = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-has-revolved");
            var display_made_additional_payments_div = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments--div");
            var display_made_additional_payments = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments");
            var display_current_loan_repayment_amount = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-current-loan-repayment-amount");
            var display_correct_loan_repayment_amount = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-correct-loan-repayment-amount");
            var display_amount_of_months_paid_term = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-months-paid");
            var display_loan_term_end_date = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-loan-term-end-date");
            var display_variable_interest_rate = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-variable-interest-rate");
            if (this.haveMissedPayments.checked) {
                for (var i = 0; i < display_have_missed_payments_div.length; i++) {
                    display_have_missed_payments_div[i].classList.remove("wpbbsa-calculators-v2__hidden");
                }
            }
            else {
                for (var i = 0; i < display_have_missed_payments_div.length; i++) {
                    display_have_missed_payments_div[i].classList.add("wpbbsa-calculators-v2__hidden");
                }
            }
            if (this.revolved.checked) {
                for (var i = 0; i < display_has_revolved_div.length; i++) {
                    display_has_revolved_div[i].classList.remove("wpbbsa-calculators-v2__hidden");
                }
            }
            else {
                for (var i = 0; i < display_has_revolved_div.length; i++) {
                    display_has_revolved_div[i].classList.add("wpbbsa-calculators-v2__hidden");
                }
            }
            if (this.madeAdditionalPayments.checked) {
                for (var i = 0; i < display_made_additional_payments_div.length; i++) {
                    display_made_additional_payments_div[i].classList.remove("wpbbsa-calculators-v2__hidden");
                }
            }
            else {
                for (var i = 0; i < display_made_additional_payments_div.length; i++) {
                    display_made_additional_payments_div[i].classList.add("wpbbsa-calculators-v2__hidden");
                }
            }
            var calculations_1 = this.doRevolvingLoan_NoLimitChangeCalculations(form, allAdditionalPayments, allAdditionalPaymentDates, allMissedPaymentDates, allRevolves, allRevolvedDates);
            // -- Calculation Error -- //
            [].slice.call(display_calculation_error).forEach(function (label) {
                label.innerHTML = calculations_1.calculationErrorMessage;
            });
            // -- Original loan amount -- //
            [].slice.call(display_original_loan_amount).forEach(function (div) {
                div.innerHTML = calculations_1.originalLoanAmount;
            });
            // -- Loan start date -- //
            [].slice.call(display_loan_start_date).forEach(function (div) {
                div.innerHTML = calculations_1.startDateOfLoan;
            });
            // -- Current loan repayment amount -- //
            [].slice
                .call(display_current_loan_repayment_amount)
                .forEach(function (div) {
                div.innerHTML = calculations_1.currentLoanRepayment;
            });
            // -- Correct loan repayment amount -- //
            [].slice
                .call(display_correct_loan_repayment_amount)
                .forEach(function (div) {
                div.innerHTML = calculations_1.correctLoanRepayment;
            });
            // -- HAVE MISSED PAYMENTS -- //
            [].slice.call(display_have_missed_payments).forEach(function (div) {
                div.innerHTML = calculations_1.haveMissedPaymentsChecked;
            });
            // -- HAS REVOLVED -- //
            [].slice.call(display_has_revolved).forEach(function (div) {
                div.innerHTML = calculations_1.hasRevolvedChecked;
            });
            // -- MADE ADDITIONAL PAYMENTS -- //
            [].slice
                .call(display_made_additional_payments)
                .forEach(function (div) {
                div.innerHTML = calculations_1.madeAdditionalPaymentsChecked;
            });
            // -- Number of months paid -- //
            [].slice
                .call(display_amount_of_months_paid_term)
                .forEach(function (div) {
                div.innerHTML = calculations_1.numberOfMonthsPaid;
            });
            // -- Loan Term end date -- //
            [].slice.call(display_loan_term_end_date).forEach(function (div) {
                div.innerHTML = calculations_1.loanTermEndDate;
            });
            // -- Variable Interest Rate -- //
            [].slice
                .call(display_variable_interest_rate)
                .forEach(function (div) {
                div.innerHTML = calculations_1.variableInterestRate;
            });
            // -- Amortisation Table -- //
            this.amortisationTableLabel.innerHTML =
                calculations_1.amortisationTable;
        }
        else if (loanType === "REVOLVING LOAN - LIMIT CHANGE") {
            var display_calculation_error = this.calculatorItemElement.querySelectorAll("label[name=plua-calculate-calculateError]");
            var display_original_loan_amount = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-loan-amount");
            var display_loan_start_date = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-date-of-loan");
            var display_have_missed_payments_div = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments--div");
            var display_have_missed_payments = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments");
            var display_has_revolved_div = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-has-revolved--div");
            var display_has_revolved = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-has-revolved");
            var display_made_additional_payments_div = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments--div");
            var display_made_additional_payments = this.calculatorItemElement.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments");
            var display_current_loan_repayment_amount = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-current-loan-repayment-amount");
            var display_correct_loan_repayment_amount = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-correct-loan-repayment-amount");
            var display_amount_of_months_paid_term = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-months-paid");
            var display_loan_term_end_date = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-loan-term-end-date");
            var display_variable_interest_rate = this.calculatorItemElement.querySelectorAll("span.js-wpbbsa-calculator-variable-interest-rate");
            if (this.haveMissedPayments.checked) {
                for (var i = 0; i < display_have_missed_payments_div.length; i++) {
                    display_have_missed_payments_div[i].classList.remove("wpbbsa-calculators-v2__hidden");
                }
            }
            else {
                for (var i = 0; i < display_have_missed_payments_div.length; i++) {
                    display_have_missed_payments_div[i].classList.add("wpbbsa-calculators-v2__hidden");
                }
            }
            if (this.revolved.checked) {
                for (var i = 0; i < display_has_revolved_div.length; i++) {
                    display_has_revolved_div[i].classList.remove("wpbbsa-calculators-v2__hidden");
                }
            }
            else {
                for (var i = 0; i < display_has_revolved_div.length; i++) {
                    display_has_revolved_div[i].classList.add("wpbbsa-calculators-v2__hidden");
                }
            }
            if (this.madeAdditionalPayments.checked) {
                for (var i = 0; i < display_made_additional_payments_div.length; i++) {
                    display_made_additional_payments_div[i].classList.remove("wpbbsa-calculators-v2__hidden");
                }
            }
            else {
                for (var i = 0; i < display_made_additional_payments_div.length; i++) {
                    display_made_additional_payments_div[i].classList.add("wpbbsa-calculators-v2__hidden");
                }
            }
            var calculations_2 = this.doRevolvingLoan_LimitChangeCalculations(form, allAdditionalPayments, allAdditionalPaymentDates, allMissedPaymentDates, allRevolves, allRevolvedDates);
            // -- Calculation Error -- //
            [].slice.call(display_calculation_error).forEach(function (label) {
                label.innerHTML = calculations_2.calculationErrorMessage;
            });
            // -- Original loan amount -- //
            [].slice.call(display_original_loan_amount).forEach(function (div) {
                div.innerHTML = calculations_2.originalLoanAmount;
            });
            // -- Loan start date -- //
            [].slice.call(display_loan_start_date).forEach(function (div) {
                div.innerHTML = calculations_2.startDateOfLoan;
            });
            // -- Current loan repayment amount -- //
            [].slice
                .call(display_current_loan_repayment_amount)
                .forEach(function (div) {
                div.innerHTML = calculations_2.currentLoanRepayment;
            });
            // -- Correct loan repayment amount -- //
            [].slice
                .call(display_correct_loan_repayment_amount)
                .forEach(function (div) {
                div.innerHTML = calculations_2.correctLoanRepayment;
            });
            // -- HAVE MISSED PAYMENTS -- //
            [].slice.call(display_have_missed_payments).forEach(function (div) {
                div.innerHTML = calculations_2.haveMissedPaymentsChecked;
            });
            // -- HAS REVOLVED -- //
            [].slice.call(display_has_revolved).forEach(function (div) {
                div.innerHTML = calculations_2.hasRevolvedChecked;
            });
            // -- MADE ADDITIONAL PAYMENTS -- //
            [].slice
                .call(display_made_additional_payments)
                .forEach(function (div) {
                div.innerHTML = calculations_2.madeAdditionalPaymentsChecked;
            });
            // -- Number of months paid -- //
            [].slice
                .call(display_amount_of_months_paid_term)
                .forEach(function (div) {
                div.innerHTML = calculations_2.numberOfMonthsPaid;
            });
            // -- Loan Term end date -- //
            [].slice.call(display_loan_term_end_date).forEach(function (div) {
                div.innerHTML = calculations_2.loanTermEndDate;
            });
            // -- Variable Interest Rate -- //
            [].slice
                .call(display_variable_interest_rate)
                .forEach(function (div) {
                div.innerHTML = calculations_2.variableInterestRate;
            });
            // -- Amortisation Table -- //
            this.amortisationTableLabel.innerHTML =
                calculations_2.amortisationTable;
        }
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.doTermLoanCalculations = function (form, allAdditionalPayments, allAdditionalPaymentDates, allMissedPaymentDates) {
        var loanAmount = form.querySelector("input[name=loan-amount]");
        var dateOfLoan = form.querySelector("input[name=date-of-loan]");
        var loanTerm = form.querySelector("input[name=term]");
        var initialInterest = form.querySelector("input[name=variable_interest_rate]");
        var insurance = form.querySelector("select[name=term-loan-insurance-type]");
        var currentMonthlyInstalment = form.querySelector("input[name=current-monthly-instalment]");
        var currentMonthlyInstalmentValue = Number(currentMonthlyInstalment.value);
        var monthlyServiceFee = 69.0;
        var initiationFee = Math.min(74.5 + 0.115 * loanAmount.value, 1207.5);
        var insuranceAmount = this.getInsuranceValue(insurance.value);
        var primeInterestRate = this.getPrimeInterestRateValue(new Date(dateOfLoan.value));
        var initailInterestRateMargin = initialInterest.value - primeInterestRate;
        var startDate = new Date(dateOfLoan.value);
        var startBalance = Number(loanAmount.value) + initiationFee;
        var arrAmortisation = new Array();
        var arrAmortisationCount = 0;
        var amortisationItemStart = new AmortisationItem();
        amortisationItemStart.date = startDate;
        amortisationItemStart.payment = 0.0;
        amortisationItemStart.extraPayment = 0.0;
        amortisationItemStart.missedPaymentAndRevolves = 0.0;
        amortisationItemStart.monthlyServiceFee = 0.0;
        amortisationItemStart.insuranceCost = 0.0;
        amortisationItemStart.interest = 0.0;
        amortisationItemStart.balance = startBalance;
        amortisationItemStart.interestRate =
            primeInterestRate + initailInterestRateMargin;
        arrAmortisation.push(amortisationItemStart);
        var increaseCountLimit = 0;
        var calculationError = false;
        var calculationErrorMessage = "";
        var newLoanCalc = 0;
        var newBalanceGreaterThanLoan = false;
        while (arrAmortisation[arrAmortisationCount].balance > 0) {
            var newDate = this.addMonth(startDate, arrAmortisation[arrAmortisationCount].date);
            var newExtraPayment = 0.0;
            if (this.madeAdditionalPayments.checked) {
                for (var i = 0; i < this.numberOfAdditionalPayments; i++) {
                    if (newDate.getMonth() ===
                        allAdditionalPaymentDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allAdditionalPaymentDates[i].getFullYear()) {
                        newExtraPayment += allAdditionalPayments[i];
                    }
                }
            }
            var newMissedPayment = 0.0;
            if (this.haveMissedPayments.checked) {
                for (var i = 0; i < this.numberOfMissedPayments; i++) {
                    if (newDate.getMonth() ===
                        allMissedPaymentDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allMissedPaymentDates[i].getFullYear()) {
                        newMissedPayment = currentMonthlyInstalmentValue;
                    }
                }
            }
            var newMonthlyServiceFee = arrAmortisation[arrAmortisationCount].balance > 0
                ? monthlyServiceFee
                : 0.0;
            var insuranceCostCalc = (insuranceAmount / 1000) *
                arrAmortisation[arrAmortisationCount].balance;
            var newInsuranceCost = Math.round((insuranceCostCalc + Number.EPSILON) * 100.0) /
                100.0;
            var interestCalc = (arrAmortisation[arrAmortisationCount].interestRate /
                100.0 /
                12) *
                arrAmortisation[arrAmortisationCount].balance;
            var newInterest = Math.round((interestCalc + Number.EPSILON) * 100.0) / 100.0;
            var paymentCalc = arrAmortisation[arrAmortisationCount].balance <
                currentMonthlyInstalmentValue
                ? arrAmortisation[arrAmortisationCount].balance +
                    newInterest +
                    newInsuranceCost +
                    newMonthlyServiceFee +
                    newMissedPayment -
                    newExtraPayment
                : currentMonthlyInstalmentValue;
            var newPayment = Math.round((paymentCalc + Number.EPSILON) * 100.0) / 100.0;
            var balanceCalc = arrAmortisation[arrAmortisationCount].balance +
                newMissedPayment +
                newMonthlyServiceFee +
                newInsuranceCost +
                newInterest -
                (newPayment + newExtraPayment);
            var newBalance = Math.round((balanceCalc + Number.EPSILON) * 100) / 100;
            var newPrimeInterestRate = this.getPrimeInterestRateValue(newDate);
            var newInterestRate = newPrimeInterestRate + initailInterestRateMargin;
            if (newBalance > arrAmortisation[arrAmortisationCount].balance) {
                increaseCountLimit++;
                if (newBalance > Number(loanAmount.value)) {
                    newLoanCalc = newBalance;
                    newBalanceGreaterThanLoan = true;
                }
                if (increaseCountLimit > 10) {
                    calculationError = true;
                    calculationErrorMessage =
                        "Based upon what you’ve entered, your current loan repayment calculated is lower than what you’re supposed to be paying. Paying less will result in your loan not being settled in the agreed term. Please contact us on 0860 000 000 to adjust your repayment.";
                    break;
                }
            }
            var newAmortisationItem = new AmortisationItem();
            newAmortisationItem.date = newDate;
            newAmortisationItem.payment = newPayment;
            newAmortisationItem.extraPayment = newExtraPayment;
            newAmortisationItem.missedPaymentAndRevolves = newMissedPayment;
            newAmortisationItem.monthlyServiceFee = newMonthlyServiceFee;
            newAmortisationItem.insuranceCost = newInsuranceCost;
            newAmortisationItem.interest = newInterest;
            newAmortisationItem.balance = newBalance;
            newAmortisationItem.interestRate = newInterestRate;
            arrAmortisation.push(newAmortisationItem);
            arrAmortisationCount++;
        }
        // -- CORRECT INSTALMENT CALCULATION -- //
        var num1 = newBalanceGreaterThanLoan
            ? newLoanCalc + initiationFee
            : Number(loanAmount.value) + initiationFee;
        var num2 = Number(initialInterest.value) / 100 / 12;
        var num3 = 1 + num2;
        var negTermsLoan = Number(loanTerm.value) * -1;
        var num4 = Math.pow(num3, negTermsLoan);
        var num5 = 1 - num4;
        var num6 = num2 / num5;
        var num7 = num1 * num6;
        var num8 = num7 * Number(loanTerm.value);
        var num9 = monthlyServiceFee * Number(loanTerm.value) + num8;
        var totalInsuranceCost = 0.0;
        for (var i = 0; i < arrAmortisation.length; i++) {
            totalInsuranceCost += arrAmortisation[i].insuranceCost;
        }
        var num10 = num9 + totalInsuranceCost;
        var correctLoanRepayment = Math.round((num10 / Number(loanTerm.value) + Number.EPSILON) * 100) / 100;
        // -- CORRECT INSTALMENT CALCULATION -- //
        // -- Original loan amount -- //
        var originalLoanAmount = loanAmount.value;
        // -- Start date of loan -- //
        var startDateOfLoan = "";
        var dtStartDateOfLoan;
        if (dateOfLoan.value !== "" && dateOfLoan.value != null) {
            dtStartDateOfLoan = new Date(dateOfLoan.value);
            if (dtStartDateOfLoan) {
                startDateOfLoan =
                    dtStartDateOfLoan.getDate().toString() +
                        " " +
                        this.monthNames[dtStartDateOfLoan.getMonth()].toString() +
                        " " +
                        dtStartDateOfLoan.getFullYear().toString();
            }
        }
        // -- Current Loan Repayment Amount -- //
        var currentLoanRepayment = currentMonthlyInstalment.value.toString();
        // -- Number of months paid -- //
        var numberOfMonthsPaid = "";
        if (dtStartDateOfLoan) {
            numberOfMonthsPaid = this.getNumberOfMonthsPaid(arrAmortisation);
        }
        // -- Loan term end date -- //
        var loanTermEndDate = "";
        if (calculationError === true) {
            loanTermEndDate = "No End Date";
        }
        else {
            if (arrAmortisation[arrAmortisation.length - 1].date) {
                loanTermEndDate =
                    this.monthNames[arrAmortisation[arrAmortisation.length - 1].date.getMonth()].toString() +
                        " " +
                        arrAmortisation[arrAmortisation.length - 1].date
                            .getFullYear()
                            .toString();
            }
        }
        // -- Variable interest rate -- //
        var variableInterestRate = initialInterest.value.toString() + '%';
        // -- Amortisation Table -- //
        var amortisationTable = "";
        if (calculationError === true) {
            amortisationTable =
                "<p>Based upon what you’ve entered, your current loan repayment calculated is lower than what you’re supposed to be paying. Paying less will result in your loan not being settled in the agreed term. Please contact us on 0860 000 000 to adjust your repayment.</p>";
        }
        else {
            amortisationTable = "<table class=\"calculators-personalloans-amortisation__table\">\n\t\t\t<thead>\n\t\t\t<tr class=\"calculators-personalloans-amortisation__table--tr\">\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Month</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Payments</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Extra Payments</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Missed Payments & Revolves</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Monthly Service Fee</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Insurance Cost</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Interest</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Balance</th>\n\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>";
            for (var i = 0; i < arrAmortisation.length; i++) {
                amortisationTable +=
                    '<tr class="calculators-personalloans-amortisation__table--tr">';
                amortisationTable +=
                    '<td scope="row" data-label="Month" class="calculators-personalloans-amortisation__table--td">' +
                        this.monthNames[arrAmortisation[i].date.getMonth()]
                            .toString()
                            .substring(0, 3) +
                        " " +
                        arrAmortisation[i].date.getFullYear().toString() +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].payment) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Extra Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].extraPayment) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Missed Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].missedPaymentAndRevolves) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Monthly Service Fee" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].monthlyServiceFee) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Insurance Cost" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].insuranceCost) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Interest" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].interest) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Balance" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].balance) +
                        "</td>";
                amortisationTable += "</tr>";
            }
            amortisationTable += "</tbody>";
            amortisationTable += "</table>";
            amortisationTable +=
                '<div class="calculators-personalloans-amortisation__table-disclaimer"><h4>Disclaimer</h4><p>This online calculator provides an indication only. You use this online calculator at your own discretion. Standard Bank gives no warranty, express or implied, as to the accuracy, reliability and completeness of any information, formulae or calculation provided through the use of this calculator and does not accept any liability for loss or damage of whatsoever nature, which may be attributable to the reliance on and use of this calculator. We do not warrant the integrity and security of this calculator or that it is free of errors, corruption, viruses, interception or interference.</p></div>';
        }
        this.amortisationTableLabel.innerHTML = amortisationTable;
        return {
            originalLoanAmount: originalLoanAmount,
            startDateOfLoan: startDateOfLoan,
            haveMissedPaymentsChecked: this.haveMissedPayments.checked
                ? "Yes"
                : "No",
            hasRevolvedChecked: this.revolved.checked ? "Yes" : "No",
            madeAdditionalPaymentsChecked: this.madeAdditionalPayments.checked
                ? "Yes"
                : "No",
            currentLoanRepayment: currentLoanRepayment,
            correctLoanRepayment: correctLoanRepayment,
            numberOfMonthsPaid: numberOfMonthsPaid,
            loanTermEndDate: loanTermEndDate,
            variableInterestRate: variableInterestRate,
            amortisationTable: amortisationTable,
            calculationErrorMessage: calculationErrorMessage,
        };
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.doRevolvingLoan_LimitChangeCalculations = function (form, allAdditionalPayments, allAdditionalPaymentDates, allMissedPaymentDates, allRevolves, allRevolvedDates) {
        var loanAmount = form.querySelector("input[name=loan-amount]");
        var dateOfLoan = form.querySelector("input[name=date-of-loan]");
        var loanTerm = form.querySelector("input[name=term]");
        var initialInterest = form.querySelector("input[name=variable_interest_rate]");
        var insurance = form.querySelector("select[name=revolving-loan-insurance-type]");
        var currentMonthlyInstalment = form.querySelector("input[name=current-monthly-instalment]");
        var currentMonthlyInstalmentValue = Number(currentMonthlyInstalment.value);
        var monthlyServiceFee = 69.0;
        var initiationFee = 0.0;
        var insuranceAmount = this.getInsuranceValue(insurance.value);
        var primeInterestRate = this.getPrimeInterestRateValue(new Date(dateOfLoan.value));
        var initailInterestRateMargin = initialInterest.value - primeInterestRate;
        var startDate = new Date(dateOfLoan.value);
        var startBalance = Number(loanAmount.value) + initiationFee;
        var arrAmortisation = new Array();
        var arrAmortisationCount = 0;
        var amortisationItemStart = new AmortisationItem();
        amortisationItemStart.date = startDate;
        amortisationItemStart.payment = 0.0;
        amortisationItemStart.extraPayment = 0.0;
        amortisationItemStart.missedPaymentAndRevolves = 0.0;
        amortisationItemStart.monthlyServiceFee = 0.0;
        amortisationItemStart.insuranceCost = 0.0;
        amortisationItemStart.interest = 0.0;
        amortisationItemStart.balance = startBalance;
        amortisationItemStart.interestRate =
            primeInterestRate + initailInterestRateMargin;
        arrAmortisation.push(amortisationItemStart);
        var increaseCountLimit = 0;
        var calculationError = false;
        var calculationErrorMessage = "";
        var newLoanCalc = 0;
        var newBalanceGreaterThanLoan = false;
        while (arrAmortisation[arrAmortisationCount].balance > 0) {
            var newDate = this.addMonth(startDate, arrAmortisation[arrAmortisationCount].date);
            var newExtraPayment = 0.0;
            if (this.madeAdditionalPayments.checked) {
                for (var i = 0; i < this.numberOfAdditionalPayments; i++) {
                    if (newDate.getMonth() ===
                        allAdditionalPaymentDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allAdditionalPaymentDates[i].getFullYear()) {
                        newExtraPayment += allAdditionalPayments[i];
                    }
                }
            }
            var newMissedPayment = 0.0;
            if (this.haveMissedPayments.checked) {
                for (var i = 0; i < this.numberOfMissedPayments; i++) {
                    if (newDate.getMonth() ===
                        allMissedPaymentDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allMissedPaymentDates[i].getFullYear()) {
                        newMissedPayment = currentMonthlyInstalmentValue;
                    }
                }
            }
            var newRevolveAmount = 0.0;
            if (this.revolved.checked) {
                for (var i = 0; i < this.numberOfRevolves; i++) {
                    if (newDate.getMonth() === allRevolvedDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allRevolvedDates[i].getFullYear()) {
                        newRevolveAmount += allRevolves[i];
                    }
                }
            }
            var newMonthlyServiceFee = arrAmortisation[arrAmortisationCount].balance > 0
                ? monthlyServiceFee
                : 0.0;
            var insuranceCostCalc = (insuranceAmount / 1000) *
                arrAmortisation[arrAmortisationCount].balance;
            var newInsuranceCost = Math.round((insuranceCostCalc + Number.EPSILON) * 100.0) /
                100.0;
            var interestCalc = (arrAmortisation[arrAmortisationCount].interestRate /
                100.0 /
                12) *
                arrAmortisation[arrAmortisationCount].balance;
            var newInterest = Math.round((interestCalc + Number.EPSILON) * 100.0) / 100.0;
            var paymentCalc = arrAmortisation[arrAmortisationCount].balance <
                currentMonthlyInstalmentValue
                ? arrAmortisation[arrAmortisationCount].balance +
                    newInterest +
                    newInsuranceCost +
                    newMonthlyServiceFee +
                    newMissedPayment -
                    newExtraPayment
                : currentMonthlyInstalmentValue;
            var newPayment = Math.round((paymentCalc + Number.EPSILON) * 100.0) / 100.0;
            var balanceCalc = arrAmortisation[arrAmortisationCount].balance +
                newMissedPayment +
                newRevolveAmount +
                newMonthlyServiceFee +
                newInsuranceCost +
                newInterest -
                (newPayment + newExtraPayment);
            var newBalance = Math.round((balanceCalc + Number.EPSILON) * 100) / 100;
            var newPrimeInterestRate = this.getPrimeInterestRateValue(newDate);
            var newInterestRate = newPrimeInterestRate + initailInterestRateMargin;
            if (newBalance > arrAmortisation[arrAmortisationCount].balance) {
                increaseCountLimit++;
                if (newBalance > Number(loanAmount.value)) {
                    newLoanCalc = newBalance;
                    newBalanceGreaterThanLoan = true;
                }
                if (increaseCountLimit > 10) {
                    calculationError = true;
                    calculationErrorMessage =
                        "Based upon what you’ve entered, your current loan repayment calculated is lower than what you’re supposed to be paying. Paying less will result in your loan not being settled in the agreed term. Please contact us on 0860 000 000 to adjust your repayment.";
                    break;
                }
            }
            var newAmortisationItem = new AmortisationItem();
            newAmortisationItem.date = newDate;
            newAmortisationItem.payment = newPayment;
            newAmortisationItem.extraPayment = newExtraPayment;
            newAmortisationItem.missedPaymentAndRevolves =
                newMissedPayment + newRevolveAmount;
            newAmortisationItem.monthlyServiceFee = newMonthlyServiceFee;
            newAmortisationItem.insuranceCost = newInsuranceCost;
            newAmortisationItem.interest = newInterest;
            newAmortisationItem.balance = newBalance;
            newAmortisationItem.interestRate = newInterestRate;
            arrAmortisation.push(newAmortisationItem);
            arrAmortisationCount++;
        }
        // -- CORRECT INSTALMENT CALCULATION -- //
        var num1 = newBalanceGreaterThanLoan
            ? newLoanCalc + initiationFee
            : Number(loanAmount.value) + initiationFee;
        var num2 = Number(initialInterest.value) / 100 / 12;
        var num3 = 1 + num2;
        var negTermsLoan = Number(loanTerm.value) * -1;
        var num4 = Math.pow(num3, negTermsLoan);
        var num5 = 1 - num4;
        var num6 = num2 / num5;
        var num7 = num1 * num6;
        var num8 = num7 * Number(loanTerm.value);
        var num9 = monthlyServiceFee * Number(loanTerm.value) + num8;
        var totalInsuranceCost = 0.0;
        for (var i = 0; i < arrAmortisation.length; i++) {
            totalInsuranceCost += arrAmortisation[i].insuranceCost;
        }
        var num10 = num9 + totalInsuranceCost;
        var correctLoanRepayment = Math.round((num10 / Number(loanTerm.value) + Number.EPSILON) * 100) / 100;
        // -- CORRECT INSTALMENT CALCULATION -- //
        // -- Original loan amount
        var originalLoanAmount = loanAmount.value;
        // -- Start date of loan -- //
        var startDateOfLoan = "";
        var dtStartDateOfLoan;
        if (dateOfLoan.value !== "" && dateOfLoan.value != null) {
            dtStartDateOfLoan = new Date(dateOfLoan.value);
            if (dtStartDateOfLoan) {
                startDateOfLoan =
                    dtStartDateOfLoan.getDate().toString() +
                        " " +
                        this.monthNames[dtStartDateOfLoan.getMonth()].toString() +
                        " " +
                        dtStartDateOfLoan.getFullYear().toString();
            }
        }
        // -- Current Loan Repayment Amount -- //
        var currentLoanRepayment = currentMonthlyInstalment.value.toString();
        // -- Number of months paid == //
        var numberOfMonthsPaid = "";
        if (dtStartDateOfLoan) {
            numberOfMonthsPaid = this.getNumberOfMonthsPaid(arrAmortisation);
        }
        // -- Loan term end date -- //
        var loanTermEndDate = "";
        if (calculationError === true) {
            loanTermEndDate = "No End Date";
        }
        else {
            if (arrAmortisation[arrAmortisation.length - 1].date) {
                loanTermEndDate =
                    this.monthNames[arrAmortisation[arrAmortisation.length - 1].date.getMonth()].toString() +
                        " " +
                        arrAmortisation[arrAmortisation.length - 1].date
                            .getFullYear()
                            .toString();
            }
        }
        // -- Variable interest rate -- //
        var variableInterestRate = initialInterest.value.toString() + '%';
        // -- Amortisation Table -- //
        var amortisationTable = "";
        if (calculationError === true) {
            amortisationTable =
                "<p>Based upon what you’ve entered, your current loan repayment calculated is lower than what you’re supposed to be paying. Paying less will result in your loan not being settled in the agreed term. Please contact us on 0860 000 000 to adjust your repayment.</p>";
        }
        else {
            amortisationTable = "<table class=\"calculators-personalloans-amortisation__table\">\n\t\t\t<thead>\n\t\t\t<tr class=\"calculators-personalloans-amortisation__table--tr\">\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Month</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Payments</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Extra Payments</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Missed Payments & Revolves</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Monthly Service Fee</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Insurance Cost</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Interest</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Balance</th>\n\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>";
            for (var i = 0; i < arrAmortisation.length; i++) {
                amortisationTable +=
                    '<tr class="calculators-personalloans-amortisation__table--tr">';
                amortisationTable +=
                    '<td scope="row" data-label="Month" class="calculators-personalloans-amortisation__table--td">' +
                        this.monthNames[arrAmortisation[i].date.getMonth()]
                            .toString()
                            .substring(0, 3) +
                        " " +
                        arrAmortisation[i].date.getFullYear().toString() +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].payment) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Extra Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].extraPayment) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Missed Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].missedPaymentAndRevolves) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Monthly Service Fee" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].monthlyServiceFee) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Insurance Cost" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].insuranceCost) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Interest" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].interest) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Balance" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].balance) +
                        "</td>";
                amortisationTable += "</tr>";
            }
            amortisationTable += "</tbody>";
            amortisationTable += "</table>";
            amortisationTable +=
                '<div class="calculators-personalloans-amortisation__table-disclaimer"><h4>Disclaimer</h4><p>This online calculator provides an indication only. You use this online calculator at your own discretion. Standard Bank gives no warranty, express or implied, as to the accuracy, reliability and completeness of any information, formulae or calculation provided through the use of this calculator and does not accept any liability for loss or damage of whatsoever nature, which may be attributable to the reliance on and use of this calculator. We do not warrant the integrity and security of this calculator or that it is free of errors, corruption, viruses, interception or interference.</p></div>';
        }
        this.amortisationTableLabel.innerHTML = amortisationTable;
        return {
            originalLoanAmount: originalLoanAmount,
            startDateOfLoan: startDateOfLoan,
            haveMissedPaymentsChecked: this.haveMissedPayments.checked
                ? "Yes"
                : "No",
            hasRevolvedChecked: this.revolved.checked ? "Yes" : "No",
            madeAdditionalPaymentsChecked: this.madeAdditionalPayments.checked
                ? "Yes"
                : "No",
            currentLoanRepayment: currentLoanRepayment,
            correctLoanRepayment: correctLoanRepayment,
            numberOfMonthsPaid: numberOfMonthsPaid,
            loanTermEndDate: loanTermEndDate,
            variableInterestRate: variableInterestRate,
            amortisationTable: amortisationTable,
            calculationErrorMessage: calculationErrorMessage,
        };
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.doRevolvingLoan_NoLimitChangeCalculations = function (form, allAdditionalPayments, allAdditionalPaymentDates, allMissedPaymentDates, allRevolves, allRevolvedDates) {
        var loanAmount = form.querySelector("input[name=loan-amount]");
        var dateOfLoan = form.querySelector("input[name=date-of-loan]");
        var loanTerm = form.querySelector("input[name=term]");
        var initialInterest = form.querySelector("input[name=variable_interest_rate]");
        var insurance = form.querySelector("select[name=revolving-loan-insurance-type]");
        var currentMonthlyInstalment = form.querySelector("input[name=current-monthly-instalment]");
        var currentMonthlyInstalmentValue = Number(currentMonthlyInstalment.value);
        var monthlyServiceFee = 69.0;
        var initiationFee = Math.min(74.5 + 0.115 * loanAmount.value, 1207.5);
        var insuranceAmount = this.getInsuranceValue(insurance.value);
        var primeInterestRate = this.getPrimeInterestRateValue(new Date(dateOfLoan.value));
        var initailInterestRateMargin = initialInterest.value - primeInterestRate;
        var startDate = new Date(dateOfLoan.value);
        var startBalance = Number(loanAmount.value) + initiationFee;
        var arrAmortisation = new Array();
        var arrAmortisationCount = 0;
        var amortisationItemStart = new AmortisationItem();
        amortisationItemStart.date = startDate;
        amortisationItemStart.payment = 0.0;
        amortisationItemStart.extraPayment = 0.0;
        amortisationItemStart.missedPaymentAndRevolves = 0.0;
        amortisationItemStart.monthlyServiceFee = 0.0;
        amortisationItemStart.insuranceCost = 0.0;
        amortisationItemStart.interest = 0.0;
        amortisationItemStart.balance = startBalance;
        amortisationItemStart.interestRate =
            primeInterestRate + initailInterestRateMargin;
        arrAmortisation.push(amortisationItemStart);
        var increaseCountLimit = 0;
        var calculationError = false;
        var calculationErrorMessage = "";
        var newLoanCalc = 0;
        var newBalanceGreaterThanLoan = false;
        while (arrAmortisation[arrAmortisationCount].balance > 0) {
            var newDate = this.addMonth(startDate, arrAmortisation[arrAmortisationCount].date);
            var newExtraPayment = 0.0;
            if (this.madeAdditionalPayments.checked) {
                for (var i = 0; i < this.numberOfAdditionalPayments; i++) {
                    if (newDate.getMonth() ===
                        allAdditionalPaymentDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allAdditionalPaymentDates[i].getFullYear()) {
                        newExtraPayment += allAdditionalPayments[i];
                    }
                }
            }
            var newMissedPayment = 0.0;
            if (this.haveMissedPayments.checked) {
                for (var i = 0; i < this.numberOfMissedPayments; i++) {
                    if (newDate.getMonth() ===
                        allMissedPaymentDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allMissedPaymentDates[i].getFullYear()) {
                        newMissedPayment = currentMonthlyInstalmentValue;
                    }
                }
            }
            var newRevolveAmount = 0.0;
            if (this.revolved.checked) {
                for (var i = 0; i < this.numberOfRevolves; i++) {
                    if (newDate.getMonth() === allRevolvedDates[i].getMonth() &&
                        newDate.getFullYear() ===
                            allRevolvedDates[i].getFullYear()) {
                        newRevolveAmount += allRevolves[i];
                    }
                }
            }
            var newMonthlyServiceFee = arrAmortisation[arrAmortisationCount].balance > 0
                ? monthlyServiceFee
                : 0.0;
            var insuranceCostCalc = (insuranceAmount / 1000) *
                arrAmortisation[arrAmortisationCount].balance;
            var newInsuranceCost = Math.round((insuranceCostCalc + Number.EPSILON) * 100.0) /
                100.0;
            var interestCalc = (arrAmortisation[arrAmortisationCount].interestRate /
                100.0 /
                12) *
                arrAmortisation[arrAmortisationCount].balance;
            var newInterest = Math.round((interestCalc + Number.EPSILON) * 100.0) / 100.0;
            var paymentCalc = arrAmortisation[arrAmortisationCount].balance <
                currentMonthlyInstalmentValue
                ? arrAmortisation[arrAmortisationCount].balance +
                    newInterest +
                    newInsuranceCost +
                    newMonthlyServiceFee +
                    newMissedPayment -
                    newExtraPayment
                : currentMonthlyInstalmentValue;
            var newPayment = Math.round((paymentCalc + Number.EPSILON) * 100.0) / 100.0;
            var balanceCalc = arrAmortisation[arrAmortisationCount].balance +
                newMissedPayment +
                newRevolveAmount +
                newMonthlyServiceFee +
                newInsuranceCost +
                newInterest -
                (newPayment + newExtraPayment);
            var newBalance = Math.round((balanceCalc + Number.EPSILON) * 100) / 100;
            var newPrimeInterestRate = this.getPrimeInterestRateValue(newDate);
            var newInterestRate = newPrimeInterestRate + initailInterestRateMargin;
            if (newBalance > arrAmortisation[arrAmortisationCount].balance) {
                increaseCountLimit++;
                if (newBalance > Number(loanAmount.value)) {
                    newLoanCalc = newBalance;
                    newBalanceGreaterThanLoan = true;
                }
                if (increaseCountLimit > 10) {
                    calculationError = true;
                    calculationErrorMessage =
                        "Based upon what you’ve entered, your current loan repayment calculated is lower than what you’re supposed to be paying. Paying less will result in your loan not being settled in the agreed term. Please contact us on 0860 000 000 to adjust your repayment.";
                    break;
                }
            }
            var newAmortisationItem = new AmortisationItem();
            newAmortisationItem.date = newDate;
            newAmortisationItem.payment = newPayment;
            newAmortisationItem.extraPayment = newExtraPayment;
            newAmortisationItem.missedPaymentAndRevolves =
                newMissedPayment + newRevolveAmount;
            newAmortisationItem.monthlyServiceFee = newMonthlyServiceFee;
            newAmortisationItem.insuranceCost = newInsuranceCost;
            newAmortisationItem.interest = newInterest;
            newAmortisationItem.balance = newBalance;
            newAmortisationItem.interestRate = newInterestRate;
            arrAmortisation.push(newAmortisationItem);
            arrAmortisationCount++;
        }
        // -- CORRECT INSTALMENT CALCULATION -- //
        var num1 = newBalanceGreaterThanLoan
            ? newLoanCalc + initiationFee
            : Number(loanAmount.value) + initiationFee;
        var num2 = Number(initialInterest.value) / 100 / 12;
        var num3 = 1 + num2;
        var negTermsLoan = Number(loanTerm.value) * -1;
        var num4 = Math.pow(num3, negTermsLoan);
        var num5 = 1 - num4;
        var num6 = num2 / num5;
        var num7 = num1 * num6;
        var num8 = num7 * Number(loanTerm.value);
        var num9 = monthlyServiceFee * Number(loanTerm.value) + num8;
        var totalInsuranceCost = 0.0;
        for (var i = 0; i < arrAmortisation.length; i++) {
            totalInsuranceCost += arrAmortisation[i].insuranceCost;
        }
        var num10 = num9 + totalInsuranceCost;
        var correctLoanRepayment = Math.round((num10 / Number(loanTerm.value) + Number.EPSILON) * 100) / 100;
        // -- CORRECT INSTALMENT CALCULATION -- //
        // -- Original loan amount -- //
        var originalLoanAmount = loanAmount.value;
        // -- Start date of loan -- //
        var startDateOfLoan = "";
        var dtStartDateOfLoan;
        if (dateOfLoan.value !== "" && dateOfLoan.value != null) {
            dtStartDateOfLoan = new Date(dateOfLoan.value);
            if (dtStartDateOfLoan) {
                startDateOfLoan =
                    dtStartDateOfLoan.getDate().toString() +
                        " " +
                        this.monthNames[dtStartDateOfLoan.getMonth()].toString() +
                        " " +
                        dtStartDateOfLoan.getFullYear().toString();
            }
        }
        // -- Current Loan Repayment Amount -- //
        var currentLoanRepayment = currentMonthlyInstalment.value.toString();
        // -- Number of months paid -- //
        var numberOfMonthsPaid = "";
        if (dtStartDateOfLoan) {
            numberOfMonthsPaid = this.getNumberOfMonthsPaid(arrAmortisation);
        }
        // -- Loan term end date -- //
        var loanTermEndDate = "";
        if (calculationError === true) {
            loanTermEndDate = "No End Date";
        }
        else {
            if (arrAmortisation[arrAmortisation.length - 1].date) {
                loanTermEndDate =
                    this.monthNames[arrAmortisation[arrAmortisation.length - 1].date.getMonth()].toString() +
                        " " +
                        arrAmortisation[arrAmortisation.length - 1].date
                            .getFullYear()
                            .toString();
            }
        }
        // -- Variable interest rate -- //
        var variableInterestRate = initialInterest.value.toString() + '%';
        // -- Amortisation Table -- //
        var amortisationTable = "";
        if (calculationError === true) {
            amortisationTable =
                "<p>Based upon what you’ve entered, your current loan repayment calculated is lower than what you’re supposed to be paying. Paying less will result in your loan not being settled in the agreed term. Please contact us on 0860 000 000 to adjust your repayment.</p>";
        }
        else {
            amortisationTable = "<table class=\"calculators-personalloans-amortisation__table\">\n\t\t\t<thead>\n\t\t\t<tr class=\"calculators-personalloans-amortisation__table--tr\">\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Month</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Payments</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Extra Payments</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Missed Payments & Revolves</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Monthly Service Fee</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Insurance Cost</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Interest</th>\n\t\t\t<th scope=\"col\" class=\"calculators-personalloans-amortisation__table--th\">Balance</th>\n\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>";
            for (var i = 0; i < arrAmortisation.length; i++) {
                amortisationTable +=
                    '<tr class="calculators-personalloans-amortisation__table--tr">';
                amortisationTable +=
                    '<td scope="row" data-label="Month" class="calculators-personalloans-amortisation__table--td">' +
                        this.monthNames[arrAmortisation[i].date.getMonth()]
                            .toString()
                            .substring(0, 3) +
                        " " +
                        arrAmortisation[i].date.getFullYear().toString() +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].payment) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Extra Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].extraPayment) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Missed Payments" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].missedPaymentAndRevolves) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Monthly Service Fee" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].monthlyServiceFee) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Insurance Cost" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].insuranceCost) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Interest" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].interest) +
                        "</td>";
                amortisationTable +=
                    '<td data-label="Balance" class="calculators-personalloans-amortisation__table--td">' +
                        this.getAmortisationTableValue(arrAmortisation[i].balance) +
                        "</td>";
                amortisationTable += "</tr>";
            }
            amortisationTable += "</tbody>";
            amortisationTable += "</table>";
            amortisationTable +=
                '<div class="calculators-personalloans-amortisation__table-disclaimer"><h4>Disclaimer</h4><p>This online calculator provides an indication only. You use this online calculator at your own discretion. Standard Bank gives no warranty, express or implied, as to the accuracy, reliability and completeness of any information, formulae or calculation provided through the use of this calculator and does not accept any liability for loss or damage of whatsoever nature, which may be attributable to the reliance on and use of this calculator. We do not warrant the integrity and security of this calculator or that it is free of errors, corruption, viruses, interception or interference.</p></div>';
        }
        this.amortisationTableLabel.innerHTML = amortisationTable;
        return {
            originalLoanAmount: originalLoanAmount,
            startDateOfLoan: startDateOfLoan,
            haveMissedPaymentsChecked: this.haveMissedPayments.checked
                ? "Yes"
                : "No",
            hasRevolvedChecked: this.revolved.checked ? "Yes" : "No",
            madeAdditionalPaymentsChecked: this.madeAdditionalPayments.checked
                ? "Yes"
                : "No",
            currentLoanRepayment: currentLoanRepayment,
            correctLoanRepayment: correctLoanRepayment,
            numberOfMonthsPaid: numberOfMonthsPaid,
            loanTermEndDate: loanTermEndDate,
            variableInterestRate: variableInterestRate,
            amortisationTable: amortisationTable,
            calculationErrorMessage: calculationErrorMessage,
        };
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.getAmortisationTableValue = function (value) {
        if (value === 0 || value === "0") {
            return "0";
        }
        else {
            return value.toFixed(2);
        }
    };
    // -- FUNCTIONS -- //
    WpbbsaCalculatorPersonalloansAmortisation.prototype.addMonth = function (startPaymentDate, date) {
        var isLeapYear = false;
        var startPaymentDay = Number(startPaymentDate.getDate());
        var paymentmonth = Number(date.getMonth());
        var paymentYear = Number(date.getFullYear());
        if (paymentYear % 400 === 0 ||
            (paymentYear % 4 === 0 && paymentYear % 100 !== 0)) {
            isLeapYear = true;
        }
        if (startPaymentDay === 31) {
            if (paymentmonth === 2 ||
                paymentmonth === 4 ||
                paymentmonth === 7 ||
                paymentmonth === 9) {
                return new Date(paymentYear, paymentmonth + 1, 30);
            }
            else if (paymentmonth === 6) {
                return new Date(paymentYear, paymentmonth + 1, 31);
            }
            else if (paymentmonth === 11) {
                return new Date(paymentYear + 1, 0, 31);
            }
            else if (paymentmonth === 0) {
                if (isLeapYear) {
                    return new Date(paymentYear, 1, 29);
                }
                else {
                    return new Date(paymentYear, 1, 28);
                }
            }
            else {
                return new Date(paymentYear, paymentmonth + 1, 31);
            }
        }
        else if (startPaymentDay === 30) {
            if (paymentmonth === 0) {
                if (isLeapYear) {
                    return new Date(paymentYear, 1, 29);
                }
                else {
                    return new Date(paymentYear, 1, 28);
                }
            }
            else {
                return new Date(paymentYear, paymentmonth + 1, 30);
            }
        }
        else if (startPaymentDay === 29) {
            if (paymentmonth === 0) {
                if (isLeapYear) {
                    return new Date(paymentYear, 1, 29);
                }
                else {
                    return new Date(paymentYear, 1, 28);
                }
            }
            else {
                return new Date(paymentYear, paymentmonth + 1, 29);
            }
        }
        else {
            return new Date(paymentYear, paymentmonth + 1, startPaymentDay);
        }
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.getNumberOfMonthsPaid = function (arrAmortisation) {
        var numberOfMonthsPaid = 0;
        var todaysDate = new Date();
        for (var i = 0; i < arrAmortisation.length; i++) {
            if (new Date(arrAmortisation[i].date) <= todaysDate) {
                if (arrAmortisation[i].missedPaymentAndRevolves > 0.0 &&
                    arrAmortisation[i].extraPayment > 0.0) {
                    numberOfMonthsPaid += 0;
                }
                else if (arrAmortisation[i].missedPaymentAndRevolves > 0.0) {
                    numberOfMonthsPaid -= 1;
                }
                else if (arrAmortisation[i].payment > 0.0) {
                    numberOfMonthsPaid += 1;
                }
                else {
                    numberOfMonthsPaid += 0;
                }
            }
            else {
                break;
            }
        }
        if (numberOfMonthsPaid <= 0) {
            return "0 Months";
        }
        else if (numberOfMonthsPaid === 1) {
            return "1 Month";
        }
        else {
            return numberOfMonthsPaid.toString() + " Months";
        }
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.getInsuranceValue = function (insurance) {
        if (insurance === "DEBT PROTECTION PLAN") {
            return 4.5;
        }
        else if (insurance === "COMPREHENSIVE") {
            return 2.74;
        }
        else if (insurance === "SELECT") {
            return 2.23;
        }
        else if (insurance === "BASIC") {
            return 1.42;
        }
        else {
            return 0;
        }
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.getPrimeInterestRateValue = function (date) {
        var constInterestRate = 20.25;
        var constPrimeRate = 10.0;
        // -- MONTH VARIABLE BEGINS AT 0 -- //
        if (date >= new Date(2010, Month.MARCH, 1) &&
            date < new Date(2010, Month.SEPTEMBER, 1)) {
            return 10.0;
        }
        else if (date >= new Date(2010, Month.SEPTEMBER, 1) &&
            date < new Date(2010, Month.NOVEMBER, 1)) {
            return 9.5;
        }
        else if (date >= new Date(2010, Month.NOVEMBER, 1) &&
            date < new Date(2012, Month.JULY, 1)) {
            return 9.0;
        }
        else if (date >= new Date(2012, Month.JULY, 1) &&
            date < new Date(2014, Month.JANUARY, 1)) {
            return 8.5;
        }
        else if (date >= new Date(2014, Month.JANUARY, 1) &&
            date < new Date(2014, Month.JULY, 1)) {
            return 9.0;
        }
        else if (date >= new Date(2014, Month.JULY, 1) &&
            date < new Date(2015, Month.JULY, 1)) {
            return 9.25;
        }
        else if (date >= new Date(2015, Month.JULY, 1) &&
            date < new Date(2015, Month.NOVEMBER, 1)) {
            return 9.5;
        }
        else if (date >= new Date(2015, Month.NOVEMBER, 1) &&
            date < new Date(2016, Month.JANUARY, 1)) {
            return 9.75;
        }
        else if (date >= new Date(2016, Month.JANUARY, 1) &&
            date < new Date(2016, Month.MARCH, 1)) {
            return 10.25;
        }
        else if (date >= new Date(2016, Month.MARCH, 1) &&
            date < new Date(2017, Month.JULY, 1)) {
            return 10.5;
        }
        else if (date >= new Date(2017, Month.JULY, 1) &&
            date < new Date(2018, Month.APRIL, 1)) {
            return 10.25;
        }
        else if (date >= new Date(2018, Month.APRIL, 1) &&
            date < new Date(2018, Month.NOVEMBER, 1)) {
            return 10.0;
        }
        else if (date >= new Date(2018, Month.NOVEMBER, 1) &&
            date < new Date(2019, Month.JULY, 1)) {
            return 10.25;
        }
        else if (date >= new Date(2019, Month.JULY, 1) &&
            date < new Date(2020, Month.JANUARY, 1)) {
            return 10.0;
        }
        else if (date >= new Date(2020, Month.JANUARY, 1)) {
            return 9.75;
        }
        else {
            return constPrimeRate;
        }
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.updateSlider = function (event) {
        var field = event.target;
        var value = (field.value - field.min) / (field.max - field.min) * 100;
        var filedBackground = "linear-gradient(to right, #0033AA " + value + "%, #E3E6EA " + value + "%)";
        field.style.background = filedBackground;
    };
    WpbbsaCalculatorPersonalloansAmortisation.prototype.initialiseSliders = function () {
        this.sliders.forEach(function (element) {
            var value = (element.value - element.min) / (element.max - element.min) * 100;
            var filedBackground = "linear-gradient(to right, #0033AA " + value + "%, #E3E6EA " + value + "%)";
            element.style.background = filedBackground;
        });
    };
    // -- RESET VALUES - FORM -- //
    WpbbsaCalculatorPersonalloansAmortisation.prototype.resetForm = function () {
        this.inputs.map(function (item) {
            if (item.getAttribute('type') !== 'radio') {
                item.setAttribute('data-value', 0);
                item.setAttribute('placeholder', 0);
            }
            if (item.classList.contains('form__datepicker')) {
                item.setAttribute('data-value', '');
                item.setAttribute('placeholder', 'Select date');
            }
        });
        this.calculatorForm.reset();
        if ($(window).width() < 768) {
            this.calculatorInfo.classList.add('hidden');
        }
        var _numberOfAdditionalPayments = this.numberOfAdditionalPayments;
        var _numberOfMissedPayments = this.numberOfMissedPayments;
        var _numberOfRevolves = this.numberOfRevolves;
        for (var i = 0; i < _numberOfAdditionalPayments; i++) {
            this.removeAdditionalPayment();
        }
        for (var i = 0; i < _numberOfMissedPayments; i++) {
            this.removeMissedPayment();
        }
        for (var i = 0; i < _numberOfRevolves; i++) {
            this.removeRevolved();
        }
        this.updateMadeAnAdditionalPayment(false);
        this.updateHaveMissedPayment(false);
        this.updateRevolved(false);
        this.loanType = "TERM LOAN";
        // reset form
        this.dataHtmlCollection.forEach(function (item, index) {
            if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-first") != -1) {
                // item.classList.remove("hidden");
                var itemParent = item.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                itemParent.classList.remove("wpbbsa-calculators-v2__hidden");
            }
            if (item.innerHTML.indexOf("form-item__insurance--personal__policy-number-type-container-second") != -1) {
                // item.classList.add("hidden");
                var itemParent = item.closest('.wpbbsa-calculator-form-v2__group-parent-div');
                itemParent.classList.add("wpbbsa-calculators-v2__hidden");
            }
        });
        this.updateFormLoanType(this.loanType);
        this.initialiseSliders();
        // Analytics - Trigger form Complete when the user calculates the results
        this.analyticsService.dtmRestartForm();
    };
    // -- RESET VALUES - OUTPUTS -- //
    WpbbsaCalculatorPersonalloansAmortisation.prototype.resetValues = function () {
        this.resetForm();
        var original_loan_amount = document.querySelectorAll("span.js-wpbbsa-calculator-loan-amount");
        var curent_loan_repayment_amount = document.querySelectorAll("span.js-wpbbsa-calculator-current-loan-repayment-amount");
        var correct_loan_repayment_amount = document.querySelectorAll("span.js-wpbbsa-calculator-correct-loan-repayment-amount");
        var original_loan_date = document.querySelectorAll("span.js-wpbbsa-calculator-date-of-loan");
        var have_missed_payments = document.querySelectorAll("span.js-wpbbsa-calculator-have-missed-payments");
        var has_revolved = document.querySelectorAll("span.js-wpbbsa-calculator-has-revolved");
        var made_additional_payments = document.querySelectorAll("span.js-wpbbsa-calculator-made-additional-payments");
        var months_paid = document.querySelectorAll("span.js-wpbbsa-calculator-months-paid");
        var loan_term_end_date = document.querySelectorAll("span.js-wpbbsa-calculator-loan-term-end-date");
        var variable_interest_rate = document.querySelectorAll("span.js-wpbbsa-calculator-variable-interest-rate");
        var display_have_missed_payments_div = document.querySelectorAll(".js-wpbbsa-calculator-have-missed-payments--div");
        var display_has_revolved_div = document.querySelectorAll(".js-wpbbsa-calculator-has-revolved--div");
        var display_made_additional_payments_div = document.querySelectorAll(".js-wpbbsa-calculator-made-additional-payments--div");
        [].slice.call(original_loan_amount).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(curent_loan_repayment_amount).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(correct_loan_repayment_amount).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(original_loan_date).forEach(function (div) {
            div.innerHTML = "DD/MM/YYYY";
        });
        [].slice.call(have_missed_payments).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(has_revolved).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(made_additional_payments).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(months_paid).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(loan_term_end_date).forEach(function (div) {
            div.innerHTML = "DD/MM/YYYY";
        });
        [].slice.call(variable_interest_rate).forEach(function (div) {
            div.innerHTML = "0";
        });
        [].slice.call(display_have_missed_payments_div).forEach(function (div) {
            div.classList.add("wpbbsa-calculators-v2__hidden");
        });
        [].slice.call(display_has_revolved_div).forEach(function (div) {
            div.classList.add("wpbbsa-calculators-v2__hidden");
        });
        [].slice
            .call(display_made_additional_payments_div)
            .forEach(function (div) {
            div.classList.add("wpbbsa-calculators-v2__hidden");
        });
    };
    return WpbbsaCalculatorPersonalloansAmortisation;
}());
export { WpbbsaCalculatorPersonalloansAmortisation };



//////////////////
// WEBPACK FOOTER
// ./services/wpbbsa-calculator.service.ts
// module id = 63
// module chunks = 0